import "./modalRegistrarFicha.css";
import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";
import TablaConstrucciones from "./tablaConstruccion";
import { validaSoloNumero, formatMoneda, timeout } from "../../util/varios";
import useTableFijo from "../useTableFijo";
import useTableFijo2 from "../useTableFijo2";
import AgregarRegistroInm from "./agregarRegistroInm";
import moment from "moment";
import axios from "axios";
import TablaDeudaInmueble from "../hacienda/inmueblesUrbanos/tablaDeudaInmueble";
import TablaHistoricosInmuebles from "../hacienda/inmueblesUrbanos/tablaHistoricoInmuebe";
import ModalCoordenadas from "./modalCoordenadas";
import domtoimage from "dom-to-image";
import {
  DangerButton,
  PrimaryButton,
  SuccessButton,
  WarningButton,
} from "../../ui/buttons/Button";
import {
  Checkbox,
  Input,
  SearchInput,
  Select,
  Textarea,
} from "../../ui/inputs/Input";
import MapaCatastro from "./mapa";
import ModalClaseTerreno from "./modalClaseTerreno";

const headCells = [
  {
    id: "1",
    label: "NUMERO",
    width: "auto",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "2",
    label: "FOLIO",
    width: "auto",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "3",
    label: "TOMO",
    width: "auto",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "4",
    label: "PROTOCOLO",
    width: "auto",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "5",
    label: "ASIENTO REGISTRAL",
    width: "auto",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "6",
    label: "FECHA",
    width: "auto",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "7",
    label: "TERRENO",
    width: "auto",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "8",
    label: "CONSTRUCCIÓN",
    width: "auto",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "9",
    label: "MONTO BS.",
    width: "auto",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];

const headCells2 = [
  {
    id: "1",
    label: "VERTICE",
    width: "auto",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "2",
    label: "NORTE",
    width: "auto",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "3",
    label: "ESTE",
    width: "auto",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];

export const ActualizarFicha = (props) => {
  let map;
  const cambiarstatus =
    JSON.parse(localStorage.getItem("acccamstainmue")) === null
      ? "0"
      : JSON.parse(localStorage.getItem("acccamstainmue")).trim();
  const [latitud, setLatitud] = useState(9.549884372804192);
  const [longitud, setLongitud] = useState(-69.20455936500002);
  const [navigatorCheck, setNavigatorCheck] = useState(false);
  const [itemSelectR, setItemSelectR] = useState({ index: -1, item: "" });
  const [showClasificador, setShowClasificador] = useState(false)
  // useEffect(() => {
  //   setLatitud(-66.78637511787088);
  //   setLongitud(7.7164351124155);

  //   if (!navigator.geolocation) return alert("Location is not supported");

  //   navigator.geolocation.getCurrentPosition((coords) => {
  //     setNavigatorCheck(true);
  //     const { latitude, longitude } = coords.coords;

  //     setLatitud(latitude);
  //     setLongitud(longitude);
  //   });

  //   setMapImg("");
  // }, []);

  let op = require("../../../src/modulos/datos");
  //const txtTipoCaracter = useRef();
  const txtIdClaseTerreno = useRef();
  const txtDesClaseTerreno = useRef();
  const txtNumFicha = useRef();
  const txtNumInscrip = useRef();
  const txtFechaInscrip = useRef();
  const txtCCEdo = useRef();
  const txtCCMun = useRef();
  const txtCCAm = useRef();
  const txtCCSect = useRef();
  const txtCCManz = useRef();
  const txtCCParr = useRef();
  const txtCCParc = useRef();
  const txtCCSubp = useRef();
  const txtCCNiv = useRef();
  const txtCCUni = useRef();
  const txtNomParr = useRef();
  const txtDir6 = useRef();
  const txtDir1 = useRef();
  const txtDir2 = useRef();
  const txtDir3 = useRef();
  const txtDir4 = useRef();
  const txtDir5 = useRef();
  const txtNCInm = useRef();
  const txtTlfInm = useRef();
  const txtPRInm = useRef();
  const txtNomOcupante = useRef();
  const txtRifOcupante = useRef();
  const txtCidOcupante = useRef();
  const txtUrbOcupante = useRef();
  const txtNomPropietario = useRef();
  const txtRifPropietario = useRef();
  const txtCidPorpietario = useRef();
  const txtDirPro1 = useRef();
  const txtDirPro2 = useRef();
  const txtDirPro3 = useRef();
  const txtDirPro4 = useRef();
  const txtDirPro5 = useRef();
  const txtNCOcupante = useRef();
  const txtTlfPropietario = useRef();
  const txtPRPropietario = useRef();
  const cmbForma = useRef();
  const txtObsTerr = useRef();
  const txtAnioConst = useRef();
  const txtPorcenRefa = useRef();
  const txtAnioRefa = useRef();
  const txtNNiv = useRef();
  const txtNEdifi = useRef();
  const txtEdadEfec = useRef();
  const txtLinderoNorte = useRef();
  const txtLinderoSur = useRef();
  const txtLinderoEste = useRef();
  const txtLinderoOeste = useRef();

  const cmbCCAm = useRef();
  const cmbDir6 = useRef();
  const cmbDir1 = useRef();
  const cmbDir2 = useRef();
  const cmbDir3 = useRef();
  const cmbDir4 = useRef();
  const cmbDir5 = useRef();
  const cmbPerOcupante = useRef();
  const cmbUrbOcupante = useRef();
  const cmbPerPropietario = useRef();
  const cmbProRepLeg = useRef();
  const cmbDirPro1 = useRef();
  const cmbDirPro2 = useRef();
  const cmbDirPro3 = useRef();
  const cmbDirPro4 = useRef();
  const cmbDirPro5 = useRef();
  const cmbTipoZona = useRef();
  const cmbTopografia = useRef();
  const cmbAccTerr = useRef();
  const cmbUbiTerr = useRef();
  const cmbEntorFisco = useRef();
  const cmbTenTerr = useRef();
  const cmbRegPro = useRef();
  const cmbUsoActu = useRef();
  const cmbClaseInm = useRef();
  const cmbTipoInm = useRef();
  const cmbTenConst = useRef();
  const cmbRegimenPropi = useRef();
  const cmbEstConser = useRef();
  const txtLongitud = useRef();
  const txtLatitud = useRef();
  const txtPuntogeo = useRef();
  const txtNortegeo = useRef();
  const txtEstegeo = useRef();
  const [txtTipoCaracter, setTxtTipoCaracter] = useState();
  const [imagen, setImagen] = useState({
    imagen: "subir.png",
    imagenactual: "subir.png",
  });
  const [pathImage, setPathImage] = useState({
    imagen: `${op.imagenreportes}/imagencatastro?img=subir.png`,
  });
  const [imagen2, setImagen2] = useState({
    imagen: "subir.png",
    imagenactual: "subir.png",
  });
  const [pathImage2, setPathImage2] = useState({
    imagen: `${op.imagenreportes}/imagencatastro?img=subir.png`,
  });
  const [modalCoordenadas, setModalCoordenadas] = useState({
    show: false,
    operacion: 1,
  });
  const [seleccionarCoordenada, setSelectCoordenada] = useState({
    index: -1,
    item: [],
  });
  const [mapImg, setMapImg] = useState();
  const [records, setRecords] = useState([]);
  const [mostrarRegsitro, setMostrarRegistro] = useState(false);
  const [records2, setRecords2] = useState([]);
  const [records3, setRecords3] = useState([]);
  const [detalle, setDetalle] = useState();
  const [tipoZonas, setTipoZonas] = useState();
  const [operacionP, setOperacionP] = useState();
  const [activo, setActivo] = useState(true);
  const [itemSelect] = useState(-1);
  const [idinmu, setIdinmu] = useState();
  const [tipoInmueble, setTipoInmueble] = useState();
  const [uso, setUso] = useState();
  const [values, setValues] = useState({
    idinmueble: "",
    numficha: "",
    numinscripcion: "",
    fechainscripcion: "",
    codigoanterior: "",
    codigocatastral: "",
    parroquia: "",
    dirinmue1: "",
    descridirinmue1: "",
    dirinmue2: "",
    descridirinmue2: "",
    dirinmue3: "",
    descridirinmue3: "",
    dirinmue4: "",
    descridirinmue4: "",
    dirinmue5: "",
    descridirinmue5: "",
    numcivicoinmue: "",
    telefonoinmue: "",
    ptoreferenciainmue: "",
    tipoperocupante: "",
    nombreocupante: "",
    cedulaocupante: "",
    ciudadocupante: "",
    urbocupante: "",
    nomurbocupante: "",
    tipoperpropie: "",
    nombrepropie: "",
    cedulapropie: "",
    ciudadpropie: "",
    tipopropie: "",
    dirpropie1: "",
    descridirpropie1: "",
    dirpropie2: "",
    descridirpropie2: "",
    dirpropie3: "",
    descridirpropie3: "",
    dirpropie4: "",
    descridirpropie4: "",
    dirpropie5: "",
    descridirpropie5: "",
    numcivicopropie: "",
    telefonopropie: "",
    ptoreferenciapropie: "",
    topografiaterreno: "",
    accesoterreno: "",
    formaterreno: "",
    ubicacionterreno: "",
    entornoterreno: "",
    mejorasterreno: "",
    tenenciaterreno: "",
    regpropieterreno: "",
    usoterreno: "",
    serviciospublicos: "",
    obserterreno: "",
    tipoconstruccion: "",
    usoconstruccion: "",
    tenenciaconstruccion: "",
    regpropieconstruccion: "",
    soporteconstruccion: "",
    techoconstruccion: "",
    cubiertaconstruccion: "",
    tipoparedes: "",
    acabadoparedes: "",
    estadoconsevacion: "",
    anioconstruccion: "",
    aniorefaccion: "",
    porcentajerefaccion: "",
    numniveles: "",
    numedificaciones: "",
    edadefectiva: "",
    areaterreno: "",
    areamunicipal: "",
    valorm2terreno: "",
    areaajuste: "",
    formaajuste: "",
    valorajustadomt2: "",
    valorterreno: "",
    fechaavaluo: "",
    areaconstruccion: "",
    valorconstruccion: "",
    linderonorte: "",
    linderosur: "",
    linderoeste: "",
    linderooeste: "",
    utmnorte: "",
    utmeste: "",
    huso: "",
    idvalorfiscalterreno: "",
    idvalorfiscalconstruccion: "",
    idvalorterreno: "",
    montoimpuesto: "",
    status: "61",
    numerochequesdevuelto: "",
    fechaultimopago: "",
    observacionstatus: "",
    ritm: "",
    valorm2terrenopriv: "",
    dirinmue6: "",
    descridirinmue6: "",
    exonerado: "",
    credito: "",
    tipozona: "",
    idclaseterreno: "",
    idclaseinmueble: "",
    idtipoinmueble: "",
    porcebenef: "",
    puntogeo: "",
    nortegeo: "",
    estegeo: "",
    dirinmueble: "",
    exonintereses: "",
    exonmultas: "",
    exonrecargos: "",
  });
  const [filterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [activate, setActivate] = useState(false);
  const [fechaSistema] = useState(localStorage.getItem("fechasistema"));
  const [mejorasterreno, setMejorTerreno] = useState({
    mej1: "0",
    mej2: "0",
    mej3: "0",
    mej4: "0",
    mej5: "0",
  });
  const [soporte, setSoporte] = useState({
    sopor1: "0",
    sopor2: "0",
    sopor3: "0",
    sopor4: "0",
    sopor5: "0",
    sopor6: "0",
  });
  const [techo, setTecho] = useState({
    techo1: "0",
    techo2: "0",
    techo3: "0",
    techo4: "0",
    techo5: "0",
  });

  const [acabado, setAcabado] = useState({
    acab1: "0",
    acab2: "0",
    acab3: "0",
    acab4: "0",
  });
  const [servPublic, setServPublic] = useState({
    serv1: "0",
    serv2: "0",
    serv3: "0",
    serv4: "0",
    serv5: "0",
    serv6: "0",
    serv7: "0",
    serv8: "0",
    serv9: "0",
    serv10: "0",
    serv11: "0",
    serv12: "0",
    serv13: "0",
    serv14: "0",
    serv15: "0",
    serv16: "0",
    serv17: "0",
    serv18: "0",
    serv19: "0",
  });

  const [codCatastral, setCodCatastral] = useState({
    cod1: "0",
    cod2: "0",
    cod3: "0",
    cod4: "U",
    cod5: "0",
    cod6: "0",
    cod7: "0",
    cod8: "0",
    cod9: "0",
    cod10: "0",
    cod11: "0",
  });

  const [tipoPared, setTipoPared] = useState({
    pared1: "0",
    pared2: "0",
    pared3: "0",
    pared4: "0",
    pared5: "0",
    pared6: "0",
    pared7: "0",
    pared8: "0",
    pared9: "0",
    pared10: "0",
  });

  const [cubierta, setCubierta] = useState({
    cubi1: "0",
    cubi2: "0",
    cubi3: "0",
    cubi4: "0",
    cubi5: "0",
    cubi6: "0",
    cubi7: "0",
    cubi8: "0",
    cubi9: "0",
  });

  const [operacion, setOperacion] = useState("0");

  const {
    TblContainer,
    TblHead,
    //TblPagination,
    recordsAfterPagingAndSorting,
  } = useTableFijo(records, headCells, filterFn, 320);

  const { TblContainer2, TblHead2 } = useTableFijo2(
    records2,
    headCells2,
    filterFn,
    320,
  );

  let token = localStorage.getItem("jwtToken");
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [tabIndex, setTabIndex] = useState({
    tab1: "tab",
    tab2: "",
    tab3: "",
    tab4: "",
    tab5: "",
  });
  const [activeTab, setACtiveTab] = useState({
    tab1: "rounded nav-link active bg-blue-100 text-light",
    tab2: "rounded nav-link bg-blue-200 text-light",
    tab3: "rounded nav-link bg-blue-300 text-light",
    tab4: "rounded nav-link bg-blue-400 text-light",
    tab5: "rounded nav-link bg-blue-500 text-light",
    tab6: "rounded nav-link bg-blue-600 text-light",
    tab7: "rounded nav-link bg-blue-700 text-light",
    tab8: "rounded nav-link bg-blue-800 text-light",
  });
  /* mostar tabPanel */
  const [tabPanel, setTabPanel] = useState({
    tab1: "tab-pane fade show active",
    tab2: "tab-pane fade",
    tab3: "tab-pane fade",
    tab4: "tab-pane fade",
    tab5: "tab-pane fade",
    tab6: "tab-pane fade",
    tab7: "tab-pane fade",
    tab8: "tab-pane fade",
  });
  const [tabvalid, setTabValid] = useState({
    tab1: "true",
    tab2: "false",
    tab3: "false",
    tab4: "false",
    tab5: "false",
    tab6: "false",
    tab7: "false",
    tab8: "false",
  });

  const blanquear = () => {
    setImagen({ imagen: "subir.png", imagenactual: "subir.png" });
    setPathImage({
      imagen: `${op.imagenreportes}/imagen?img=subir.png`,
    });
    setImagen2({ imagen: "subir.png", imagenactual: "subir.png" });
    setPathImage2({
      imagen: `${op.imagenreportes}/imagen?img=subir.png`,
    });
    setValues({
      idinmueble: "",
      numficha: "",
      numinscripcion: "",
      fechainscripcion: "",
      codigoanterior: "",
      codigocatastral: "",
      parroquia: "",
      dirinmue1: "",
      descridirinmue1: "",
      dirinmue2: "",
      descridirinmue2: "",
      dirinmue3: "",
      descridirinmue3: "",
      dirinmue4: "",
      descridirinmue4: "",
      dirinmue5: "",
      descridirinmue5: "",
      numcivicoinmue: "",
      telefonoinmue: "",
      ptoreferenciainmue: "",
      tipoperocupante: "",
      nombreocupante: "",
      cedulaocupante: "",
      ciudadocupante: "",
      urbocupante: "",
      nomurbocupante: "",
      tipoperpropie: "",
      nombrepropie: "",
      cedulapropie: "",
      ciudadpropie: "",
      tipopropie: "",
      dirpropie1: "",
      descridirpropie1: "",
      dirpropie2: "",
      descridirpropie2: "",
      dirpropie3: "",
      descridirpropie3: "",
      dirpropie4: "",
      descridirpropie4: "",
      dirpropie5: "",
      descridirpropie5: "",
      numcivicopropie: "",
      telefonopropie: "",
      ptoreferenciapropie: "",
      topografiaterreno: "",
      accesoterreno: "",
      formaterreno: "",
      ubicacionterreno: "",
      entornoterreno: "",
      mejorasterreno: "",
      tenenciaterreno: "",
      regpropieterreno: "",
      usoterreno: "",
      serviciospublicos: "",
      obserterreno: "",
      tipoconstruccion: "",
      usoconstruccion: "",
      tenenciaconstruccion: "",
      regpropieconstruccion: "",
      soporteconstruccion: "",
      techoconstruccion: "",
      cubiertaconstruccion: "",
      tipoparedes: "",
      acabadoparedes: "",
      estadoconsevacion: "",
      anioconstruccion: "",
      aniorefaccion: "",
      porcentajerefaccion: "",
      numniveles: "",
      numedificaciones: "",
      edadefectiva: "",
      areaterreno: "",
      areamunicipal: "",
      valorm2terreno: "",
      areaajuste: "",
      formaajuste: "",
      valorajustadomt2: "",
      valorterreno: "",
      fechaavaluo: "",
      areaconstruccion: "",
      valorconstruccion: "",
      linderonorte: "",
      linderosur: "",
      linderoeste: "",
      linderooeste: "",
      utmnorte: "",
      utmeste: "",
      huso: "",
      idvalorfiscalterreno: "",
      idvalorfiscalconstruccion: "",
      idvalorterreno: "",
      montoimpuesto: "",
      status: "61",
      numerochequesdevuelto: "",
      fechaultimopago: "",
      observacionstatus: "",
      ritm: "",
      valorm2terrenopriv: "",
      dirinmue6: "",
      descridirinmue6: "",
      exonerado: "",
      credito: "",
      tipozona: "",
      idclaseterreno: "",
      idclaseinmueble: "",
      idtipoinmueble: "",
      porcebenef: "",
      puntogeo: "",
      nortegeo: "",
      estegeo: "",
      dirinmueble: "",
      exonintereses: "",
      exonmultas: "",
      exonrecargos: "",
    });

    setMejorTerreno({
      mej1: "0",
      mej2: "0",
      mej3: "0",
      mej4: "0",
      mej5: "0",
    });
    setSoporte({
      sopor1: "0",
      sopor2: "0",
      sopor3: "0",
      sopor4: "0",
      sopor5: "0",
      sopor6: "0",
    });
    setTecho({
      techo1: "0",
      techo2: "0",
      techo3: "0",
      techo4: "0",
      techo5: "0",
    });

    setAcabado({
      acab1: "0",
      acab2: "0",
      acab3: "0",
      acab4: "0",
    });
    setServPublic({
      serv1: "0",
      serv2: "0",
      serv3: "0",
      serv4: "0",
      serv5: "0",
      serv6: "0",
      serv7: "0",
      serv8: "0",
      serv9: "0",
      serv10: "0",
      serv11: "0",
      serv12: "0",
      serv13: "0",
      serv14: "0",
      serv15: "0",
      serv16: "0",
      serv17: "0",
      serv18: "0",
      serv19: "0",
    });
    setCodCatastral({
      cod1: "0",
      cod2: "0",
      cod3: "0",
      cod4: "U",
      cod5: "0",
      cod6: "0",
      cod7: "0",
      cod8: "0",
      cod9: "0",
      cod10: "0",
      cod11: "0",
    });
    setTipoPared({
      pared1: "0",
      pared2: "0",
      pared3: "0",
      pared4: "0",
      pared5: "0",
      pared6: "0",
      pared7: "0",
      pared8: "0",
      pared9: "0",
      pared10: "0",
    });
    setCubierta({
      cubi1: "0",
      cubi2: "0",
      cubi3: "0",
      cubi4: "0",
      cubi5: "0",
      cubi6: "0",
      cubi7: "0",
      cubi8: "0",
      cubi9: "0",
    });
    setActivo(true);
    setItemSelectR({
      index: -1,
      item: "",
    });
    setLatitud(9.549884372804192);
    setLongitud(-69.20455936500002);
  };
  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (mensajesino.texto === "Seguro de Elminar este Registro?") {
      let arr = [];
      let nregistro = recordsAfterPagingAndSorting()[itemSelect].numeroregistro;
      for (let x = 0; x < records.length; x++) {
        if (records[x].numeroregistro !== nregistro) {
          arr.push(records[x]);
        }
      }
      setRecords(arr);
    }
  };

  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };

  const cerrarModal = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    setImagen({ imagen: "subir.png", imagenactual: "subir.png" });
    setPathImage({
      imagen: `${op.imagenreportes}/imagen?img=subir.png`,
    });
    setImagen2({ imagen: "subir.png", imagenactual: "subir.png" });
    setPathImage2({
      imagen: `${op.imagenreportes}/imagen?img=subir.png`,
    });
    props.onHideRender();
    props.onHideCancela();
  };

  const tabs = (vl) => (e) => {
    e.preventDefault();
    if (vl == 1) {
      setACtiveTab({
        tab1: "rounded nav-link bg-blue-100 text-light active ",
        tab2: "rounded nav-link bg-blue-200 text-light",
        tab3: "rounded nav-link bg-blue-300 text-light",
        tab4: "rounded nav-link bg-blue-400 text-light",
        tab5: "rounded nav-link bg-blue-500 text-light ",
        tab6: "rounded nav-link bg-blue-600 text-light ",
        tab8: " rounded nav-link bg-blue-800 text-light",
        tab7: " rounded nav-link bg-blue-700 text-light",
      });
      setTabValid({
        tab1: "true",
        tab2: "false",
        tab3: "false",
        tab4: "false",
        tab5: "false",
        tab6: "false",
        tab7: "false",
        tab8: "false",
      });
      setTabPanel({
        tab1: "tab-pane fade show active ",
        tab2: "tab-pane fade ",
        tab3: "tab-pane fade ",
        tab4: "tab-pane fade ",
        tab5: "tab-pane fade ",
        tab6: "tab-pane fade ",
        tab7: "tab-pane fade",
        tab8: "tab-pane fade",
      });
    } else if (vl === 2) {
      setACtiveTab({
        tab1: "rounded nav-link bg-blue-100 text-light",
        tab2: "rounded nav-link active bg-blue-200 text-light",
        tab3: "rounded nav-link bg-blue-300 text-light",
        tab4: "rounded nav-link bg-blue-400 text-light",
        tab5: "rounded nav-link bg-blue-500 text-light",
        tab6: "rounded nav-link bg-blue-600 text-light ",
        tab8: " rounded nav-link bg-blue-800 text-light",
        tab7: " rounded nav-link bg-blue-700 text-light",
      });
      setTabValid({
        tab1: "false",
        tab2: "true",
        tab3: "false",
        tab4: "false",
        tab5: "false",
        tab6: "false",
        tab7: "false",
        tab8: "false",
      });
      setTabPanel({
        tab1: "tab-pane fade ",
        tab2: "tab-pane fade show active ",
        tab3: "tab-pane fade ",
        tab4: "tab-pane fade ",
        tab5: "tab-pane fade ",
        tab6: "tab-pane fade ",
        tab7: "tab-pane fade",
        tab8: "tab-pane fade",
      });
    } else if (vl === 3) {
      setACtiveTab({
        tab1: "rounded nav-link bg-blue-100 text-light",
        tab2: "rounded nav-link  bg-blue-200 text-light",
        tab3: "rounded nav-link bg-blue-100 text-light active",
        tab4: "rounded nav-link bg-blue-400 text-light",
        tab5: "rounded nav-link bg-blue-500 text-light ",
        tab6: "rounded nav-link bg-blue-600 text-light ",
        tab8: " rounded nav-link bg-blue-800 text-light",
        tab7: " rounded nav-link bg-blue-700 text-light",
      });
      setTabValid({
        tab1: "false",
        tab2: "false",
        tab3: "true",
        tab4: "false",
        tab5: "false",
        tab6: "false",
        tab7: "false",
        tab8: "false",
      });
      setTabPanel({
        tab1: "tab-pane fade ",
        tab2: "tab-pane fade ",
        tab3: "tab-pane fade show active",
        tab4: "tab-pane fade ",
        tab5: "tab-pane fade ",
        tab6: "tab-pane fade ",
        tab7: "tab-pane fade",
        tab8: "tab-pane fade",
      });
    } else if (vl === 4) {
      setACtiveTab({
        tab1: "rounded nav-link bg-blue-100 text-light",
        tab2: "rounded nav-link  bg-blue-200 text-light",
        tab3: "  nav-link bg-blue-300 text-light",
        tab4: "active rounded nav-link bg-blue-400 text-light",
        tab5: "rounded nav-link bg-blue-500 text-light",
        tab6: "rounded nav-link bg-blue-600 text-light",
        tab8: " rounded nav-link bg-blue-800 text-light",
        tab7: " rounded nav-link bg-blue-700 text-light",
      });
      setTabValid({
        tab1: "false",
        tab2: "false",
        tab3: "false",
        tab4: "true",
        tab5: "false",
        tab6: "false",
        tab7: "false",
        tab8: "false",
      });
      setTabPanel({
        tab1: "tab-pane fade ",
        tab2: "tab-pane fade ",
        tab3: "tab-pane fade",
        tab6: "tab-pane fade",
        tab4: "tab-pane fade active show",
        tab5: "tab-pane fade",
        tab7: "tab-pane fade",
        tab8: "tab-pane fade",
      });
    } else if (vl === 5) {
      setACtiveTab({
        tab1: "rounded nav-link bg-blue-100 text-light",
        tab2: "rounded nav-link  bg-blue-200 text-light",
        tab3: "  nav-link bg-blue-300 text-light",
        tab4: " rounded nav-link bg-blue-400 text-light",
        tab6: " rounded nav-link bg-blue-600 text-light",
        tab5: "active rounded nav-link bg-blue-500 text-light",
        tab8: " rounded nav-link bg-blue-800 text-light",
        tab7: " rounded nav-link bg-blue-700 text-light",
      });
      setTabValid({
        tab1: "false",
        tab2: "false",
        tab3: "false",
        tab4: "false",
        tab6: "false",
        tab5: "true",
        tab7: "false",
        tab8: "false",
      });
      setTabPanel({
        tab1: "tab-pane fade ",
        tab2: "tab-pane fade ",
        tab3: "tab-pane fade",
        tab4: "tab-pane fade",
        tab6: "tab-pane fade",
        tab5: "tab-pane fade active show",
        tab7: "tab-pane fade",
        tab8: "tab-pane fade",
      });
    } else if (vl === 6) {
      setACtiveTab({
        tab1: "rounded nav-link bg-blue-100 text-light",
        tab2: "rounded nav-link  bg-blue-200 text-light",
        tab3: "  nav-link bg-blue-300 text-light",
        tab4: " rounded nav-link bg-blue-400 text-light",
        tab5: " rounded nav-link bg-blue-500 text-light",
        tab6: "active rounded nav-link bg-blue-600 text-light",
        tab8: " rounded nav-link bg-blue-800 text-light",
        tab7: " rounded nav-link bg-blue-700 text-light",
      });
      setTabValid({
        tab1: "false",
        tab2: "false",
        tab3: "false",
        tab4: "false",
        tab5: "false",
        tab6: "true",
        tab7: "false",
        tab8: "false",
      });
      setTabPanel({
        tab1: "tab-pane fade ",
        tab2: "tab-pane fade ",
        tab3: "tab-pane fade",
        tab4: "tab-pane fade",
        tab5: "tab-pane fade",
        tab6: "tab-pane fade active show",
        tab7: "tab-pane fade",
        tab8: "tab-pane fade",
      });
    } else if (vl === 7) {
      setACtiveTab({
        tab1: "rounded nav-link bg-blue-100 text-light",
        tab2: "rounded nav-link  bg-blue-200 text-light",
        tab3: "  nav-link bg-blue-300 text-light",
        tab4: " rounded nav-link bg-blue-400 text-light",
        tab5: " rounded nav-link bg-blue-500 text-light",
        tab6: " rounded nav-link bg-blue-600 text-light",
        tab8: " rounded nav-link bg-blue-800 text-light",
        tab7: "active rounded nav-link bg-blue-700 text-light",
      });
      setTabValid({
        tab1: "false",
        tab2: "false",
        tab3: "false",
        tab4: "false",
        tab5: "false",
        tab6: "false",
        tab7: "true",
        tab8: "false",
      });
      setTabPanel({
        tab1: "tab-pane fade ",
        tab2: "tab-pane fade ",
        tab3: "tab-pane fade",
        tab4: "tab-pane fade",
        tab5: "tab-pane fade",
        tab6: "tab-pane fade  ",
        tab7: "tab-pane fade active show",
        tab8: "tab-pane fade",
      });
    } else if (vl === 8) {
      setACtiveTab({
        tab1: "rounded nav-link bg-blue-100 text-light",
        tab2: "rounded nav-link  bg-blue-200 text-light",
        tab3: "  nav-link bg-blue-300 text-light",
        tab4: " rounded nav-link bg-blue-400 text-light",
        tab5: " rounded nav-link bg-blue-500 text-light",
        tab6: " rounded nav-link bg-blue-600 text-light",
        tab8: "active rounded nav-link bg-blue-800 text-light",
        tab7: " rounded nav-link bg-blue-700 text-light",
      });
      setTabValid({
        tab1: "false",
        tab2: "false",
        tab3: "false",
        tab4: "false",
        tab5: "false",
        tab6: "false",
        tab7: "false",
        tab8: "true",
      });
      setTabPanel({
        tab1: "tab-pane fade ",
        tab2: "tab-pane fade ",
        tab3: "tab-pane fade",
        tab4: "tab-pane fade",
        tab5: "tab-pane fade",
        tab6: "tab-pane fade  ",
        tab7: "tab-pane fade ",
        tab8: "tab-pane fade active show",
      });
    }
  };

  const tabs2 = (vl) => {
    if (vl == 1) {
      setACtiveTab({
        tab1: "rounded nav-link bg-blue-100 text-light active ",
        tab2: "rounded nav-link bg-blue-200 text-light",
        tab3: "rounded nav-link bg-blue-300 text-light",
        tab4: "rounded nav-link bg-blue-400 text-light",
        tab5: "rounded nav-link bg-blue-500 text-light ",
        tab6: "rounded nav-link bg-blue-600 text-light ",
        tab8: " rounded nav-link bg-blue-800 text-light",
        tab7: " rounded nav-link bg-blue-700 text-light",
      });
      setTabValid({
        tab1: "true",
        tab2: "false",
        tab3: "false",
        tab4: "false",
        tab5: "false",
        tab6: "false",
        tab7: "false",
        tab8: "false",
      });
      setTabPanel({
        tab1: "tab-pane fade show active ",
        tab2: "tab-pane fade ",
        tab3: "tab-pane fade ",
        tab4: "tab-pane fade ",
        tab5: "tab-pane fade ",
        tab6: "tab-pane fade ",
        tab7: "tab-pane fade",
        tab8: "tab-pane fade",
      });
    } else if (vl === 2) {
      setACtiveTab({
        tab1: "rounded nav-link bg-blue-100 text-light",
        tab2: "rounded nav-link active bg-blue-200 text-light",
        tab3: "rounded nav-link bg-blue-300 text-light",
        tab4: "rounded nav-link bg-blue-400 text-light",
        tab5: "rounded nav-link bg-blue-500 text-light",
        tab6: "rounded nav-link bg-blue-600 text-light ",
        tab8: " rounded nav-link bg-blue-800 text-light",
        tab7: " rounded nav-link bg-blue-700 text-light",
      });
      setTabValid({
        tab1: "false",
        tab2: "true",
        tab3: "false",
        tab4: "false",
        tab5: "false",
        tab6: "false",
        tab7: "false",
        tab8: "false",
      });
      setTabPanel({
        tab1: "tab-pane fade ",
        tab2: "tab-pane fade show active ",
        tab3: "tab-pane fade ",
        tab4: "tab-pane fade ",
        tab5: "tab-pane fade ",
        tab6: "tab-pane fade ",
        tab7: "tab-pane fade",
        tab8: "tab-pane fade",
      });
    } else if (vl === 3) {
      setACtiveTab({
        tab1: "rounded nav-link bg-blue-100 text-light",
        tab2: "rounded nav-link  bg-blue-200 text-light",
        tab3: " active nav-link bg-blue-300 text-light",
        tab4: "rounded nav-link bg-blue-400 text-light",
        tab5: "rounded nav-link bg-blue-500 text-light ",
        tab6: "rounded nav-link bg-blue-600 text-light ",
        tab8: " rounded nav-link bg-blue-800 text-light",
        tab7: " rounded nav-link bg-blue-700 text-light",
      });
      setTabValid({
        tab1: "false",
        tab2: "false",
        tab3: "true",
        tab4: "false",
        tab5: "false",
        tab6: "false",
        tab7: "false",
        tab8: "false",
      });
      setTabPanel({
        tab1: "tab-pane fade ",
        tab2: "tab-pane fade ",
        tab3: "tab-pane fade show active",
        tab4: "tab-pane fade ",
        tab5: "tab-pane fade ",
        tab6: "tab-pane fade ",
        tab7: "tab-pane fade",
        tab8: "tab-pane fade",
      });
    } else if (vl === 4) {
      setACtiveTab({
        tab1: "rounded nav-link bg-blue-100 text-light",
        tab2: "rounded nav-link  bg-blue-200 text-light",
        tab3: "  nav-link bg-blue-300 text-light",
        tab4: "active rounded nav-link bg-blue-400 text-light",
        tab5: "rounded nav-link bg-blue-500 text-light",
        tab6: "rounded nav-link bg-blue-600 text-light",
        tab8: " rounded nav-link bg-blue-800 text-light",
        tab7: " rounded nav-link bg-blue-700 text-light",
      });
      setTabValid({
        tab1: "false",
        tab2: "false",
        tab3: "false",
        tab4: "true",
        tab5: "false",
        tab6: "false",
        tab7: "false",
        tab8: "false",
      });
      setTabPanel({
        tab1: "tab-pane fade ",
        tab2: "tab-pane fade ",
        tab3: "tab-pane fade",
        tab6: "tab-pane fade",
        tab4: "tab-pane fade active show",
        tab5: "tab-pane fade",
        tab7: "tab-pane fade",
        tab8: "tab-pane fade",
      });
    } else if (vl === 5) {
      setACtiveTab({
        tab1: "rounded nav-link bg-blue-100 text-light",
        tab2: "rounded nav-link  bg-blue-200 text-light",
        tab3: "  nav-link bg-blue-300 text-light",
        tab4: " rounded nav-link bg-blue-400 text-light",
        tab6: " rounded nav-link bg-blue-600 text-light",
        tab5: "active rounded nav-link bg-blue-500 text-light",
        tab8: " rounded nav-link bg-blue-800 text-light",
        tab7: " rounded nav-link bg-blue-700 text-light",
      });
      setTabValid({
        tab1: "false",
        tab2: "false",
        tab3: "false",
        tab4: "false",
        tab6: "false",
        tab5: "true",
        tab7: "false",
        tab8: "false",
      });
      setTabPanel({
        tab1: "tab-pane fade ",
        tab2: "tab-pane fade ",
        tab3: "tab-pane fade",
        tab4: "tab-pane fade",
        tab6: "tab-pane fade",
        tab5: "tab-pane fade active show",
        tab7: "tab-pane fade",
        tab8: "tab-pane fade",
      });
    } else if (vl === 6) {
      setACtiveTab({
        tab1: "rounded nav-link bg-blue-100 text-light",
        tab2: "rounded nav-link  bg-blue-200 text-light",
        tab3: "  nav-link bg-blue-300 text-light",
        tab4: " rounded nav-link bg-blue-400 text-light",
        tab5: " rounded nav-link bg-blue-500 text-light",
        tab6: "active rounded nav-link bg-blue-600 text-light",
        tab8: " rounded nav-link bg-blue-800 text-light",
        tab7: " rounded nav-link bg-blue-700 text-light",
      });
      setTabValid({
        tab1: "false",
        tab2: "false",
        tab3: "false",
        tab4: "false",
        tab5: "false",
        tab6: "true",
        tab7: "false",
        tab8: "false",
      });
      setTabPanel({
        tab1: "tab-pane fade ",
        tab2: "tab-pane fade ",
        tab3: "tab-pane fade",
        tab4: "tab-pane fade",
        tab5: "tab-pane fade",
        tab6: "tab-pane fade active show",
        tab7: "tab-pane fade",
        tab8: "tab-pane fade",
      });
    } else if (vl === 7) {
      setACtiveTab({
        tab1: "rounded nav-link bg-blue-100 text-light",
        tab2: "rounded nav-link  bg-blue-200 text-light",
        tab3: "  nav-link bg-blue-300 text-light",
        tab4: " rounded nav-link bg-blue-400 text-light",
        tab5: " rounded nav-link bg-blue-500 text-light",
        tab6: " rounded nav-link bg-blue-600 text-light",
        tab8: " rounded nav-link bg-blue-800 text-light",
        tab7: "active rounded nav-link bg-blue-700 text-light",
      });
      setTabValid({
        tab1: "false",
        tab2: "false",
        tab3: "false",
        tab4: "false",
        tab5: "false",
        tab6: "false",
        tab7: "true",
        tab8: "false",
      });
      setTabPanel({
        tab1: "tab-pane fade ",
        tab2: "tab-pane fade ",
        tab3: "tab-pane fade",
        tab4: "tab-pane fade",
        tab5: "tab-pane fade",
        tab6: "tab-pane fade  ",
        tab7: "tab-pane fade active show",
        tab8: "tab-pane fade",
      });
    } else if (vl === 8) {
      setACtiveTab({
        tab1: "rounded nav-link bg-blue-100 text-light",
        tab2: "rounded nav-link  bg-blue-200 text-light",
        tab3: "  nav-link bg-blue-300 text-light",
        tab4: " rounded nav-link bg-blue-400 text-light",
        tab5: " rounded nav-link bg-blue-500 text-light",
        tab6: " rounded nav-link bg-blue-600 text-light",
        tab8: "active rounded nav-link bg-blue-800 text-light",
        tab7: " rounded nav-link bg-blue-700 text-light",
      });
      setTabValid({
        tab1: "false",
        tab2: "false",
        tab3: "false",
        tab4: "false",
        tab5: "false",
        tab6: "false",
        tab7: "false",
        tab8: "true",
      });
      setTabPanel({
        tab1: "tab-pane fade ",
        tab2: "tab-pane fade ",
        tab3: "tab-pane fade",
        tab4: "tab-pane fade",
        tab5: "tab-pane fade",
        tab6: "tab-pane fade  ",
        tab7: "tab-pane fade ",
        tab8: "tab-pane fade active show",
      });
    }
  };

  const seleccionarZona = () => {
    let campos = "idzonainmueble,tipo,caracteristica";
    let nomtab = "zonainmueble";
    let orden = "idzonainmueble";
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200 && response.data !== "") {
          setTipoZonas(response.data);
          if (props.operacion !== 1) {
            for (let x = 0; x < response.data.length; x++) {
              if (props.inmueble.tipozona === response.data[x].tipo) {
                //txtTipoCaracter.current.value = response.data[x].caracteristica;
                cmbTipoZona.current = { value: response.data[x].tipo };
                values.tipozona = response.data[x].tipo;
                //setValues({ ...values});
                setTxtTipoCaracter(response.data[x].caracteristica);
                break;
              }
            }
          } else {
            cmbTipoZona.current = { value: response.data[0].tipo };
            //txtTipoCaracter.current = {value : response.data[0].caracteristica};
            setTxtTipoCaracter(response.data[0].caracteristica);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response ? error.response.data.message : error.message,
          icono: "error",
        });
      });
  };

  const handleInputNumChange = (event) => {
    validaSoloNumero(event);
    if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const seleccionarRegistrosClaseInmu = (id, tipo) => {
    let campos = "*";
    let nomtab = "tipoinmueble";
    let nomid = "idclaseinmueble";
    let nomid2 = "tipo";
    let orden = "idclaseinmueble";
    let endpoint = `${op.conexion}/api/consulta/idsstring2rows?campos=${campos}&id=${id}&id2=${tipo}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200 && response.data !== "") {
          setTipoInmueble(response.data);
          setActivate(false);
        }
      })
      .catch((error) => {
        setActivate(false);
      });
  };

  const terrenoConst = (id) => {
    let endpoint = `${op.conexion}/api/inmueble/terrenoconstruccion?id=${id}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200 && response.data !== "") {
          setRecords2(response.data);
          setActivate(false);
        }
      })
      .catch((error) => {
        setActivate(false);
      });
  };
  const buscarCoordenadas = async (id) => {
    try {
      if (!id) return;
      const campos = "vertice, norte, este";
      const nomtab = `coordenadasxinmueble`;
      const nomid = `idinmueble = ${id}`;
      const endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${nomid}&orden=1=1`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      });
      if (
        response.status === 200 &&
        response.data &&
        response.data.length > 0
      ) {
        setRecords3(response.data);
      } else {
        setRecords3([]);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: error.response
          ? error.response.data.message
          : "Error al Buscar el inmueble",
        icono: "error",
      });
    } finally {
    }
  };
  const datosClasificador = (id) => {
    if (!id) return;
    let campos = "tipo,idclaseterreno,descripcion";
    let nomtab = "claseterreno";
    let nomid = "idclaseterreno";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            txtIdClaseTerreno.current.value = response.data.idclaseterreno;
            txtDesClaseTerreno.current.value =
              response.data.tipo + " .- " + response.data.descripcion.trim();
          } else {
            txtDesClaseTerreno.current.value = "";
            setActivate(false);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response ? error.response.data.message : error.message,
          icono: "error",
        });
      });
  };

  const seleccionarDetalle = (id) => {
    let campos = "*";
    let nomtab = "detalleregistro";
    let nomid = "iddetalleregistro";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200 && response.data) {
          setDetalle(response.data);
          setMostrarRegistro(true);
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: "",
          icono: "error",
        });
        setActivate(false);
      });
  };

  const validarClasificador = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        datosClasificador(event.target.value);
      } else {
        txtDesClaseTerreno.current.value = "";
      }
    }
  };

  const seleccionarRegistrosUso = () => {
    let campos = "idclaseinmueble,descripcion";
    let nomtab = "claseinmueble";
    let orden = "idclaseinmueble";
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200 && response.data) {
          setUso(response.data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response ? error.response.data.message : error.message,
          icono: "error",
        });
      });
  };
  const seleccionaRegistrosDetalles = (id) => {
    let campos = "*";
    let nomtab = "detalleregistro";
    let condi = "idinmueble=" + id;
    let orden = "1";
    let endpoint =
      op.conexion +
      `/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200 && response.data) {
          setRecords(response.data);
          if (response.data.length > 0) {
            setActivo(false);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response ? error.response.data.message : error.message,
          icono: "error",
        });
      });
  };

  const onChange = (e) => {
    if (e.target.type === "text" || e.target.type === "textarea") {
      e.target.value = e.target.value.toUpperCase();
      setValues((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
      if (e.target.name === "nombreocupante") {
        values.nombreocupante = e.target.value;
        if (values.nombrepropie === "") {
          values.nombrepropie = e.target.value;
          //setValues({ ...values, [e.target.name]: e.target.value });
          setValues({ ...values });
        } else {
          setValues({ ...values, [e.target.name]: e.target.value });
        }
      } else if (e.target.name === "cedulaocupante") {
        values.cedulaocupante = e.target.value;
        if (values.cedulapropie === "") {
          values.cedulapropie = e.target.value;
          //setValues({ ...values, [e.target.name]: e.target.value });
          setValues({ ...values });
        } else {
          setValues({ ...values, [e.target.name]: e.target.value });
        }
      } else if (e.target.name === "ciudadocupante") {
        values.ciudadocupante = e.target.value;
        if (values.ciudadpropie === "") {
          values.ciudadpropie = e.target.value;
          //setValues({ ...values, [e.target.name]: e.target.value });
          setValues({ ...values });
        } else {
          setValues({ ...values, [e.target.name]: e.target.value });
        }
      } else {
        setValues({ ...values, [e.target.name]: e.target.value });
      }
    }

    if (e.target.name === "tipoperocupante") {
      values.tipoperocupante = e.target.value;
      if (values.tipoperpropie === "0" || values.tipoperpropie === "") {
        values.tipoperpropie = e.target.value;
        setValues({ ...values });
      } else {
        setValues({ ...values, [e.target.name]: e.target.value });
      }
    } else if (e.target.name === "idclaseinmueble") {
      setValues({ ...values, [e.target.name]: e.target.value });
      seleccionarRegistrosClaseInmu(e.target.value, values.tipozona);
    } else if (e.target.name === "tipozona") {
      setValues({ ...values, [e.target.name]: e.target.value });
      cmbTipoZona.current.value = e.target.value;
      for (let x = 0; x < tipoZonas.length; x++) {
        if (e.target.value === tipoZonas[x].tipo) {
          //txtTipoCaracter.current.value = tipoZonas[x].caracteristica;
          setTxtTipoCaracter(tipoZonas[x].caracteristica);
          break;
        }
      }
    } else if (e.target.id === "codcatastral") {
      setCodCatastral({ ...codCatastral, [e.target.name]: e.target.value });
    } else {
      setValues({ ...values, [e.target.name]: e.target.value });
    }
  };
  const updateimg = (id) => {
    let endpoint = `${op.conexion}/upload`;
    let body = new FormData();
    body.append("codigo", id);
    body.append("imagenactual", imagen.imagenactual);
    body.append("imagennueva", imagen.imagen);
    body.append("imagenactual2", imagen2.imagenactual);
    body.append("imagennueva2", imagen2.imagen);
    body.append("imagennueva3", mapImg);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setImagen({ imagen: "subir.png", imagenactual: "subir.png" });
          setPathImage({
            imagen: `${op.imagenreportes}/imagen?img=subir.png`,
          });
          setImagen2({ imagen: "subir.png", imagenactual: "subir.png" });
          setPathImage2({
            imagen: `${op.imagenreportes}/imagen?img=subir.png`,
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response ? error.response.data.message : error.message,
          icono: "error",
        });
      });
  };

  const procesarDetalles = (id) => {
    let endpoint = `${op.conexion}/api/inmueble/registrardetalles`;
    let body;
    setActivate(true);
    body = {
      idinmueble: id,
      detalles: records,
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Ficha Registrada Exitosamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response ? error.response.data.message : error.message,
          icono: "error",
        });
      });
  };

  const procesarFicha = () => {
    let endpoint = `${op.conexion}/api/inmueble/actualizarinmueble`;
    let body;
    setActivate(true);
    const codanterior = 0;
    let dataFicha = [
      txtNumFicha.current.value,
      txtNumInscrip.current.value !== "" ? txtNumInscrip.current.value : "0",
      txtFechaInscrip.current.value,
      codanterior,
      codCatastral.cod1 +
        codCatastral.cod2 +
        codCatastral.cod3 +
        codCatastral.cod4 +
        codCatastral.cod5 +
        codCatastral.cod6 +
        codCatastral.cod7 +
        codCatastral.cod8 +
        codCatastral.cod9 +
        codCatastral.cod10 +
        codCatastral.cod11,
      values.status,
    ];
    let dataDirInm = [
      txtNomParr.current.value,
      cmbDir1.current.value,
      txtDir1.current.value,
      cmbDir2.current.value,
      txtDir2.current.value,
      cmbDir3.current.value,
      txtDir3.current.value,
      cmbDir4.current.value,
      txtDir4.current.value,
      cmbDir5.current.value,
      txtDir5.current.value,
      txtNCInm.current.value,
      txtTlfInm.current.value,
      txtPRInm.current.value,
      cmbDir6.current.value,
      txtDir6.current.value,
    ];
    let dataOcupante = [
      txtNomOcupante.current.value,
      txtRifOcupante.current.value,
      txtCidOcupante.current.value,
      cmbUrbOcupante.current.value,
      txtUrbOcupante.current.value,
    ];
    let dataPropietario = [
      txtNomPropietario.current.value,
      txtRifPropietario.current.value,
      txtCidPorpietario.current.value,
      cmbProRepLeg.current.value,
      cmbDirPro1.current.value,
      txtDirPro1.current.value,
      cmbDirPro2.current.value,
      txtDirPro2.current.value,
      cmbDirPro3.current.value,
      txtDirPro3.current.value,
      cmbDirPro4.current.value,
      txtDirPro4.current.value,
      cmbDirPro5.current.value,
      txtDirPro5.current.value,
      txtNCOcupante.current.value,
      txtTlfPropietario.current.value,
      txtPRPropietario.current.value,
    ];
    let mejoras =
      mejorasterreno.mej1 +
      mejorasterreno.mej2 +
      mejorasterreno.mej3 +
      mejorasterreno.mej4 +
      mejorasterreno.mej5;
    let servicios =
      servPublic.serv1 +
      servPublic.serv2 +
      servPublic.serv3 +
      servPublic.serv4 +
      servPublic.serv5 +
      servPublic.serv6 +
      servPublic.serv7 +
      servPublic.serv8 +
      servPublic.serv9 +
      servPublic.serv10 +
      servPublic.serv11 +
      servPublic.serv12 +
      servPublic.serv13 +
      servPublic.serv14 +
      servPublic.serv15 +
      servPublic.serv16 +
      servPublic.serv17 +
      servPublic.serv18 +
      servPublic.serv19;
    let dataTerreno = [
      cmbTopografia.current.value,
      cmbAccTerr.current.value,
      cmbForma.current.value,
      cmbUbiTerr.current.value,
      cmbEntorFisco.current.value,
      mejoras,
      cmbTenTerr.current.value,
      cmbRegPro.current.value,
      cmbUsoActu.current.value,
      servicios,
      txtObsTerr.current.value,
      cmbTipoZona.current.value,
    ];
    let tipoCon = 0;
    let soporteCons =
      soporte.sopor1 +
      soporte.sopor2 +
      soporte.sopor3 +
      soporte.sopor4 +
      soporte.sopor5 +
      soporte.sopor6;
    let techoCons =
      techo.techo1 + techo.techo2 + techo.techo3 + techo.techo4 + techo.techo5;
    let cubiertaCons =
      cubierta.cubi1 +
      cubierta.cubi2 +
      cubierta.cubi3 +
      cubierta.cubi4 +
      cubierta.cubi5 +
      cubierta.cubi6 +
      cubierta.cubi7 +
      cubierta.cubi8 +
      cubierta.cubi9;
    let tipopared =
      tipoPared.pared1 +
      tipoPared.pared2 +
      tipoPared.pared3 +
      tipoPared.pared4 +
      tipoPared.pared5 +
      tipoPared.pared6 +
      tipoPared.pared7 +
      tipoPared.pared8 +
      tipoPared.pared9 +
      tipoPared.pared10;
    let acabadoPared =
      acabado.acab1 + acabado.acab2 + acabado.acab3 + acabado.acab4;
    let dataConstruccion = [
      tipoCon,
      cmbClaseInm.current.value,
      cmbTenConst.current.value,
      cmbRegimenPropi.current.value,
      soporteCons,
      techoCons,
      cubiertaCons,
      tipopared,
      acabadoPared,
    ];
    let dataLinderos = [
      txtLinderoNorte.current.value,
      txtLinderoSur.current.value,
      txtLinderoEste.current.value,
      txtLinderoOeste.current.value,
    ];

    let huso = "";

    let dataCoor = [txtLongitud.current.value, txtLatitud.current.value, huso];
    body = {
      operacion: operacion,
      nid: operacion === 1 ? 0 : values.idinmueble,
      datficha: dataFicha,
      datdirinmue: dataDirInm,
      tipperocu: cmbPerOcupante.current.value
        ? parseInt(cmbPerOcupante.current.value)
        : 0,
      datocupa: dataOcupante,
      tipperpro: cmbPerPropietario.current.value
        ? parseInt(cmbPerPropietario.current.value)
        : 0,
      datpropie: dataPropietario,
      datterreno: dataTerreno,
      datconstru: dataConstruccion,
      conser: cmbEstConser.current.value,
      aniocostru: txtAnioConst.current.value
        ? parseInt(txtAnioConst.current.value)
        : 0,
      aniorefa: txtAnioRefa.current.value
        ? parseInt(txtAnioRefa.current.value)
        : 0,
      porcerefa: txtPorcenRefa.current.value
        .replace(/\./g, "")
        .replace(",", "."),
      nniveles: txtNNiv.current.value ? parseInt(txtNNiv.current.value) : 0,
      nedifi: txtNEdifi.current.value ? parseInt(txtNEdifi.current.value) : 0,
      nedad: txtEdadEfec.current.value
        ? parseInt(txtEdadEfec.current.value)
        : 0,
      areaterre: operacion === 1 ? 0 : values.areaterreno,
      valorm2: operacion === 1 ? 0 : values.valorm2terreno,
      areaaju: operacion === 1 ? 0 : values.areaajuste,
      formaaju: operacion === 1 ? 0 : values.formaajuste,
      valoraju: operacion === 1 ? 0 : values.valorajustadomt2,
      valorterre: operacion === 1 ? 0 : values.valorterreno,
      idvalterre: operacion === 1 ? 0 : values.idvalorterreno,
      fecava: operacion === 1 ? fechaSistema : values.fechaavaluo,
      valcons: operacion === 1 ? 0 : values.valorconstruccion,
      datlinde: dataLinderos,
      datcoor: dataCoor,
      areacons: operacion === 1 ? 0 : values.areaconstruccion,
      areamuni: operacion === 1 ? 0 : values.areamunicipal,
      valorterrepri: operacion === 1 ? 0 : values.valorm2terrenopriv,
      idclasterre: txtIdClaseTerreno.current.value
        ? parseInt(txtIdClaseTerreno.current.value)
        : 0,
      idclasinmu: parseInt(
        cmbClaseInm.current.value ? cmbClaseInm.current.value : 0,
      ),
      idtipoinmu: cmbTipoInm.current.value
        ? parseInt(cmbTipoInm.current.value)
        : 0,
      puntogeog: txtPuntogeo.current.value,
      nortegeog: txtNortegeo.current.value,
      estegeog: txtEstegeo.current.value,
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200 && response.data) {
          updateimg(response.data.inmueble_act);
          if (operacion === 1) {
            if (records.length > 0) {
              procesarDetalles(response.data.inmueble_act);
            } else {
              setMensaje({
                mostrar: true,
                titulo: "Exito.",
                texto: "Ficha Registrada Exitosamente",
                icono: "exito",
              });
              setActivate(false);
            }
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Ficha Modificada Exitosamente",
              icono: "exito",
            });
            setActivate(false);
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Ficha Eliminada Exitosamente",
              icono: "exito",
            });
            setActivate(false);
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response ? error.response.data.message : error.message,
          icono: "error",
        });
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    let sigue = true;
    if (txtNumFicha.current.value === "") {
      tabs2(1);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Ingresar el Numero de Ficha",
        icono: "informacion",
      });
      sigue = false;
      txtNumFicha.current.focus();
    } else if (
      txtCCEdo.current.value === "" ||
      txtCCEdo.current.value === "0"
    ) {
      tabs2(1);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "El Estado del Codigo Catastral no debe ser 0 u estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtCCEdo.current.focus();
    } else if (
      txtCCMun.current.value === "" ||
      txtCCMun.current.value === "0"
    ) {
      tabs2(1);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "El Municipio del Codigo Catastral no debe ser 0 u estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtCCMun.current.focus();
    } else if (
      txtCCParr.current.value === "" ||
      txtCCParr.current.value === "0"
    ) {
      tabs2(1);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "El Parroquia del Codigo Catastral no debe ser 0 u estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtCCParr.current.focus();
    } else if (
      txtCCSect.current.value === "" ||
      txtCCSect.current.value === "0"
    ) {
      tabs2(1);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "El Sector del Codigo Catastral no debe ser 0 u estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtCCSect.current.focus();
    } else if (
      txtCCManz.current.value === "" ||
      txtCCManz.current.value === "0"
    ) {
      tabs2(1);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "La Manzana del Codigo Catastral no debe ser 0 u estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtCCManz.current.focus();
    } else if (
      txtCCParc.current.value === "" ||
      txtCCParc.current.value === "0"
    ) {
      tabs2(1);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto:
          "El Nro. de Parcela del Codigo Catastral no debe ser 0 u estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtCCParc.current.focus();
    } else if (txtNomParr.current.value === "") {
      tabs2(1);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Ingresar el Nombre de la Parroquia",
        icono: "informacion",
      });
      sigue = false;
      txtNomParr.current.focus();
    } else if (cmbDir6.current.value === "") {
      tabs2(1);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Seleccionar La Ciudad/Comunidad",
        icono: "informacion",
      });
      sigue = false;
      cmbDir6.current.focus();
    } else if (txtDir6.current.value === "") {
      tabs2(1);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto:
          cmbDir6.current.value !== ""
            ? "Debe Introducir el nombre de el/la " +
              cmbDir6.current.value.trim()
            : "Debe Seleccionar La Ciudad/Comunidad",
        icono: "informacion",
      });
      sigue = false;
      txtDir6.current.focus();
    } else if (txtNomPropietario.current.value === "") {
      tabs2(2);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Ingresar el Nombre del Propietario",
        icono: "informacion",
      });
      sigue = false;
      txtNomPropietario.current.focus();
    } else if (txtCidPorpietario.current.value === "") {
      tabs2(2);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Ingresar La Ciudad o Localidad del Propietario",
        icono: "informacion",
      });
      sigue = false;
      txtCidPorpietario.current.focus();
    } else if (cmbProRepLeg.current.value === "") {
      tabs2(2);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Ingresar el Tipo de Responsable Legal de Inmueble",
        icono: "informacion",
      });
      sigue = false;
      cmbProRepLeg.current.focus();
    } else if (cmbTipoZona.current.value === "") {
      tabs2(2);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Seleccionar Un Tipo de Zona",
        icono: "informacion",
      });
      sigue = false;
      cmbTipoZona.current.focus();
    } else if (cmbTopografia.current.value === "") {
      tabs2(3);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Seleccionar la Topografia",
        icono: "informacion",
      });
      sigue = false;
      cmbTopografia.current.focus();
    } else if (cmbAccTerr.current.value === "") {
      tabs2(3);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Seleccionar el tipo de Acceso al terreno",
        icono: "informacion",
      });
      sigue = false;
      cmbAccTerr.current.focus();
    } else if (cmbForma.current.value === "") {
      tabs2(3);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Seleccionar la Forma del terreno",
        icono: "informacion",
      });
      sigue = false;
      cmbForma.current.focus();
    } else if (cmbUbiTerr.current.value === "") {
      tabs2(3);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Seleccionar la Ubicación del terreno",
        icono: "informacion",
      });
      sigue = false;
      cmbUbiTerr.current.focus();
    } else if (cmbEntorFisco.current.value === "") {
      tabs2(3);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Seleccionar el Entorno Fisico del terreno",
        icono: "informacion",
      });
      sigue = false;
      cmbEntorFisco.current.focus();
    } else if (cmbTenTerr.current.value === "") {
      tabs2(3);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Seleccionar la Tenencia del terreno",
        icono: "informacion",
      });
      sigue = false;
      cmbTenTerr.current.focus();
    } else if (cmbRegPro.current.value === "") {
      tabs2(3);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Seleccionar el Regimen de Propiedad del terreno",
        icono: "informacion",
      });
      sigue = false;
      cmbRegPro.current.focus();
    } else if (cmbUsoActu.current.value === "") {
      tabs2(3);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Seleccionar el Uso Actual del terreno",
        icono: "informacion",
      });
      sigue = false;
      cmbUsoActu.current.focus();
    } else if (txtLinderoNorte.current.value === "") {
      tabs2(6);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Introducir el Lindero Norte del Inmueble",
        icono: "informacion",
      });
      sigue = false;
      txtLinderoNorte.current.focus();
    } else if (txtLinderoSur.current.value === "") {
      tabs2(6);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Introducir el Lindero Sur del Inmueble",
        icono: "informacion",
      });
      sigue = false;
      txtLinderoSur.current.focus();
    } else if (txtLinderoEste.current.value === "") {
      tabs2(6);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Introducir el Lindero Este del Inmueble",
        icono: "informacion",
      });
      sigue = false;
      txtLinderoEste.current.focus();
    } else if (txtLinderoOeste.current.value === "") {
      tabs2(6);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Introducir el Lindero Oeste del Inmueble",
        icono: "informacion",
      });
      sigue = false;
      txtLinderoOeste.current.focus();
    } /* else if (!mapImg) {
      tabs2(6);
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto:
          "Imagen de mapa no guardada, por favor haga click derecho en el mapa cuando seleccione su ubicacion",
        icono: "informacion",
      });
      sigue = false;
    } */
    if (sigue) {
      procesarFicha();
    }
  };

  const registroPublico = (op) => (e) => {
    e.preventDefault();
    setOperacionP(op);
    if (operacion === 1) {
      if (op === 1) {
        setMostrarRegistro(true);
      } else if (op === 2) {
        let arr = [];
        let nregistro =
          recordsAfterPagingAndSorting()[itemSelect].numeroregistro;
        for (let x = 0; x < records.length; x++) {
          if (records[x].numeroregistro !== nregistro) {
            arr.push(records[x]);
          }
        }
        setRecords(arr);
        let foli = recordsAfterPagingAndSorting()[itemSelect].folio;
        let tom = recordsAfterPagingAndSorting()[itemSelect].tomo;
        let protocol = recordsAfterPagingAndSorting()[itemSelect].protocolo;
        let asientoreg =
          recordsAfterPagingAndSorting()[itemSelect].asientoregistral;
        let fecha = recordsAfterPagingAndSorting()[itemSelect].fecharegistro;
        let areaterr = recordsAfterPagingAndSorting()[itemSelect].areaterreno;
        let areaconstru =
          recordsAfterPagingAndSorting()[itemSelect].areaconstruccion;
        let valorinmueble =
          recordsAfterPagingAndSorting()[itemSelect].valorinmueble;
        setDetalle({
          numeroregistro: nregistro,
          folio: foli,
          tomo: tom,
          protocolo: protocol,
          asientoregistral: asientoreg,
          fecharegistro: fecha,
          areaterreno: areaterr,
          areaconstruccion: areaconstru,
          valorinmueble: valorinmueble,
        });
        setMostrarRegistro(true);
      } else if (op === 3) {
        setMensajesino({
          mostrar: true,
          titulo: "Notificación",
          texto: "Seguro de Elminar este Registro?",
          icono: "informacion",
        });
      }
    } else {
      if (op === 1) {
        setMostrarRegistro(true);
      } else {
        if (itemSelectR.index !== -1 && records.length > 0) {
          let iddetalles =
            recordsAfterPagingAndSorting()[itemSelectR.index].iddetalleregistro;
          seleccionarDetalle(iddetalles);
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Información",
            texto: "Debe Seleccionar un Registro",
            icono: "informacion",
          });
        }
      }
    }
  };

  const agregarDetalle = (values) => {
    setActivate(false);
    setMostrarRegistro(false);
    records.push(values);
  };

  const handleUpload = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const name = e.target;
      if (file.type.includes("image")) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        if (name.name === "imagen") {
          reader.onload = function load() {
            setPathImage({ ...pathImage, imagen: reader.result });
          };
        }
      }
    }
    setImagen({ ...imagen, [e.target.name]: e.target.files[0] });
  };

  const handleUpload2 = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const name = e.target;
      if (file.type.includes("image")) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        if (name.name === "imagen") {
          reader.onload = function load() {
            setPathImage2({ ...pathImage2, imagen: reader.result });
          };
        }
      }
    }
    setImagen2({ ...imagen2, [e.target.name]: e.target.files[0] });
  };

  const checked = (e) => {
    if (e.target.id === "mejoras") {
      if (mejorasterreno[e.target.name] === "1") {
        setMejorTerreno({ ...mejorasterreno, [e.target.name]: "0" });
      } else {
        setMejorTerreno({ ...mejorasterreno, [e.target.name]: "1" });
      }
    } else if (e.target.id === "servicios") {
      if (servPublic[e.target.name] === "1") {
        setServPublic({ ...servPublic, [e.target.name]: "0" });
      } else {
        setServPublic({ ...servPublic, [e.target.name]: "1" });
      }
    } else if (e.target.id === "soporte") {
      if (soporte[e.target.name] === "1") {
        setSoporte({ ...soporte, [e.target.name]: "0" });
      } else {
        setSoporte({ ...soporte, [e.target.name]: "1" });
      }
    } else if (e.target.id === "techo") {
      if (techo[e.target.name] === "1") {
        setTecho({ ...techo, [e.target.name]: "0" });
      } else {
        setTecho({ ...techo, [e.target.name]: "1" });
      }
    } else if (e.target.id === "cubierta") {
      if (cubierta[e.target.name] === "1") {
        setCubierta({ ...cubierta, [e.target.name]: "0" });
      } else {
        setCubierta({ ...cubierta, [e.target.name]: "1" });
      }
    } else if (e.target.id === "tipo") {
      if (tipoPared[e.target.name] === "1") {
        setTipoPared({ ...tipoPared, [e.target.name]: "0" });
      } else {
        setTipoPared({ ...tipoPared, [e.target.name]: "1" });
      }
    } else if (e.target.id === "acabado") {
      if (acabado[e.target.name] === "1") {
        setAcabado({ ...acabado, [e.target.name]: "0" });
      } else {
        setAcabado({ ...acabado, [e.target.name]: "1" });
      }
    }
  };

  //console.log(values.tipopropie)
  const seleccionarFila = (item, index) => {
    try {
      setItemSelectR({
        index: index,
        item: item,
      });
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error al Seleccionar el Registro",
        icono: "error",
      });
    }
  };
  const seleccionarClasificador = (item) => {
    txtIdClaseTerreno.current.value = item.idclaseterreno
    txtDesClaseTerreno.current.value = item.descripcion
  }
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        if (props.inmueble && (props.inmueble.utmeste && props.inmueble.utmnorte)) {
          const esteLimpio = props.inmueble.utmeste
            .toString()
            .trim()
            .toLowerCase();
          const norteLimpio = props.inmueble.utmnorte
            .toString()
            .trim()
            .toLowerCase();
          const esEsteValido =
            esteLimpio !== "null" &&
            esteLimpio !== "" &&
            !isNaN(Number(esteLimpio));
          const esNorteValido =
            norteLimpio !== "null" &&
            norteLimpio !== "" &&
            !isNaN(Number(norteLimpio));
          if (esEsteValido && esNorteValido) {
            setLatitud(parseFloat(esteLimpio));
            setLongitud(parseFloat(norteLimpio));
          } else {
            setLatitud(9.549884372804192)
            setLongitud(-69.20455936500002)
          }
        }
        // const $map = document.getElementById("map");
        // if (navigatorCheck) {
        //   map = L.map("map").setView([latitud, longitud], 5); // <- MAP ZOOM
        //   L.tileLayer("https://{s}.tile.osm.org/{z}/{x}/{y}.png", {
        //     maxZoom: 20,
        //     zoomDelta: 0.25,
        //     zoomSnap: 0,
        //   }).addTo(map);
        // }
        // if (!navigatorCheck) {
        //   map = L.map("map").setView([latitud, longitud], 2); // <- MAP ZOOM
        //   L.tileLayer("https://{s}.tile.osm.org/{z}/{x}/{y}.png", {
        //     maxZoom: 20,
        //     zoomDelta: 0.25,
        //     zoomSnap: 0,
        //   }).addTo(map);
        // }

        // let marker = L.marker();

        // const btn = document.createElement("button");
        // btn.innerHTML = "Reiniciar";
        // btn.classList.add("btn");
        // btn.classList.add("btn-info");
        // btn.classList.add("mb-2");

        // btn.onclick = () => {
        //   map.invalidateSize();
        //   if (!props.inmueble) return;
        //   if (!props.inmueble.utmeste) return;
        //   if (!props.inmueble.utmnorte) return;

        //   const latitude = props.inmueble.utmeste;
        //   const longitude = props.inmueble.utmnorte;

        //   if (props.operacion !== 1 && latitude && longitude) {
        //     marker.setLatLng([latitude, longitude]).addTo(map);
        //     map.setView([latitude, longitude], 15);

        //     const dataURL = domtoimage.toJpeg($map, {
        //       width: 300,
        //       height: 300,
        //     });
        //     setMapImg(dataURL);
        //     return;
        //   }

        //   if (!navigatorCheck) map.setView([latitud, longitud], 5);
        //   if (navigatorCheck) map.setView([latitud, longitud], 12);
        // };
        // $map.parentNode.prepend(btn);

        // map.on("contextmenu", async () => {
        //   const dataURL = await domtoimage.toJpeg($map, {
        //     width: 300,
        //     height: 300,
        //   });
        //   setMapImg(dataURL);
        // });

        // map.on("click", (e) => {
        //   const lat = e.latlng.lat;
        //   const lng = e.latlng.lng;

        //   setLatitud(lat);
        //   setLongitud(lng);

        //   map.setView([lat, lng]);
        //   marker.setLatLng(e.latlng).addTo(map);
        // });
        seleccionarZona();
        seleccionarRegistrosUso();
        tabs2(1);
        setOperacion(props.operacion);

        if (props.operacion !== 1) {
          if (props.inmueble !== "") {
            // GENERATE MAP WITH EXISTING COORDS
            const jpg = props.inmueble.idinmueble + "plano.jpg";
            let img2 = `${op.imagenreportes}/imagencatastro?img=${jpg}`;
            axios
              .get(img2)
              .then(function (response) {
                if (response.status === 200) {
                  setImagen({ ...imagen, imagenactual: jpg });
                  setPathImage({
                    imagen: `${op.imagenreportes}/imagencatastro?img=${jpg}`,
                  });
                }
              })
              .catch(function (error) {
                setImagen({ imagen: "subir.png", imagenactual: "subir.png" });
                setPathImage({
                  imagen: `${op.imagenreportes}/imagencatastro?img=subir.png`,
                });
              });
            const jpg2 = props.inmueble.idinmueble + "fachada.jpg";
            let img22 = `${op.imagenreportes}/imagencatastro?img=${jpg2}`;
            axios
              .get(img22)
              .then(function (response) {
                if (response.status === 200) {
                  setImagen2({ ...imagen, imagenactual: jpg });
                  setPathImage2({
                    imagen: `${op.imagenreportes}/imagencatastro?img=${jpg2}`,
                  });
                }
              })
              .catch(function (error) {
                setImagen2({ imagen: "subir.png", imagenactual: "subir.png" });
                setPathImage2({
                  imagen: `${op.imagenreportes}/imagencatastro?img=subir.png`,
                });
              });
          }
          seleccionaRegistrosDetalles(props.inmueble.idinmueble);
          setValues(props.inmueble);
          setMejorTerreno({
            mej1: props.inmueble
              ? props.inmueble.mejorasterreno
                ? props.inmueble.mejorasterreno.toString().substring(0, 1)
                : "0"
              : "0",
            mej2: props.inmueble
              ? props.inmueble.mejorasterreno
                ? props.inmueble.mejorasterreno.toString().substring(1, 2)
                : "0"
              : "0",
            mej3: props.inmueble
              ? props.inmueble.mejorasterreno
                ? props.inmueble.mejorasterreno.toString().substring(2, 3)
                : "0"
              : "0",
            mej4: props.inmueble
              ? props.inmueble.mejorasterreno
                ? props.inmueble.mejorasterreno.toString().substring(3, 4)
                : "0"
              : "0",
            mej5: props.inmueble
              ? props.inmueble.mejorasterreno
                ? props.inmueble.mejorasterreno.toString().substring(4, 5)
                : "0"
              : "0",
          });
          setSoporte({
            sopor1: props.inmueble
              ? props.inmueble.soporteconstruccion
                ? props.inmueble.soporteconstruccion.toString().substring(0, 1)
                : "0"
              : "0",
            sopor2: props.inmueble
              ? props.inmueble.soporteconstruccion
                ? props.inmueble.soporteconstruccion.toString().substring(1, 2)
                : "0"
              : "0",
            sopor3: props.inmueble
              ? props.inmueble.soporteconstruccion
                ? props.inmueble.soporteconstruccion.toString().substring(2, 3)
                : "0"
              : "0",
            sopor4: props.inmueble
              ? props.inmueble.soporteconstruccion
                ? props.inmueble.soporteconstruccion.toString().substring(3, 4)
                : "0"
              : "0",
            sopor5: props.inmueble
              ? props.inmueble.soporteconstruccion
                ? props.inmueble.soporteconstruccion.toString().substring(4, 5)
                : "0"
              : "0",
            sopor6: props.inmueble
              ? props.inmueble.soporteconstruccion
                ? props.inmueble.soporteconstruccion.toString().substring(5, 6)
                : "0"
              : "0",
          });
          setTecho({
            techo1: props.inmueble
              ? props.inmueble.techoconstruccion
                ? props.inmueble.techoconstruccion.toString().substring(0, 1)
                : "0"
              : "0",
            techo2: props.inmueble
              ? props.inmueble.techoconstruccion
                ? props.inmueble.techoconstruccion.toString().substring(1, 2)
                : "0"
              : "0",
            techo3: props.inmueble
              ? props.inmueble.techoconstruccion
                ? props.inmueble.techoconstruccion.toString().substring(2, 3)
                : "0"
              : "0",
            techo4: props.inmueble
              ? props.inmueble.techoconstruccion
                ? props.inmueble.techoconstruccion.toString().substring(3, 4)
                : "0"
              : "0",
            techo5: props.inmueble
              ? props.inmueble.techoconstruccion
                ? props.inmueble.techoconstruccion.toString().substring(4, 5)
                : "0"
              : "0",
          });
          setAcabado({
            acab1: props.inmueble
              ? props.inmueble.acabadoparedes
                ? props.inmueble.acabadoparedes.toString().substring(0, 1)
                : "0"
              : "0",
            acab2: props.inmueble
              ? props.inmueble.acabadoparedes
                ? props.inmueble.acabadoparedes.toString().substring(1, 2)
                : "0"
              : "0",
            acab3: props.inmueble
              ? props.inmueble.acabadoparedes
                ? props.inmueble.acabadoparedes.toString().substring(2, 3)
                : "0"
              : "0",
            acab4: props.inmueble
              ? props.inmueble.acabadoparedes
                ? props.inmueble.acabadoparedes.toString().substring(3, 4)
                : "0"
              : "0",
          });
          setCubierta({
            cubi1: props.inmueble
              ? props.inmueble.cubiertaconstruccion
                ? props.inmueble.cubiertaconstruccion.toString().substring(0, 1)
                : "0"
              : "0",
            cubi2: props.inmueble
              ? props.inmueble.cubiertaconstruccion
                ? props.inmueble.cubiertaconstruccion.toString().substring(1, 2)
                : "0"
              : "0",
            cubi3: props.inmueble
              ? props.inmueble.cubiertaconstruccion
                ? props.inmueble.cubiertaconstruccion.toString().substring(2, 3)
                : "0"
              : "0",
            cubi4: props.inmueble
              ? props.inmueble.cubiertaconstruccion
                ? props.inmueble.cubiertaconstruccion.toString().substring(3, 4)
                : "0"
              : "0",
            cubi5: props.inmueble
              ? props.inmueble.cubiertaconstruccion
                ? props.inmueble.cubiertaconstruccion.toString().substring(4, 5)
                : "0"
              : "0",
            cubi6: props.inmueble
              ? props.inmueble.cubiertaconstruccion
                ? props.inmueble.cubiertaconstruccion.toString().substring(5, 6)
                : "0"
              : "0",
            cubi7: props.inmueble
              ? props.inmueble.cubiertaconstruccion
                ? props.inmueble.cubiertaconstruccion.toString().substring(6, 7)
                : "0"
              : "0",
            cubi8: props.inmueble
              ? props.inmueble.cubiertaconstruccion
                ? props.inmueble.cubiertaconstruccion.toString().substring(7, 8)
                : "0"
              : "0",
            cubi9: props.inmueble
              ? props.inmueble.cubiertaconstruccion
                ? props.inmueble.cubiertaconstruccion.toString().substring(8, 9)
                : "0"
              : "0",
          });
          setServPublic({
            serv1: props.inmueble
              ? props.inmueble.serviciospublicos
                ? props.inmueble.serviciospublicos.toString().substring(0, 1)
                : "0"
              : "0",
            serv2: props.inmueble
              ? props.inmueble.serviciospublicos
                ? props.inmueble.serviciospublicos.toString().substring(1, 2)
                : "0"
              : "0",
            serv3: props.inmueble
              ? props.inmueble.serviciospublicos
                ? props.inmueble.serviciospublicos.toString().substring(2, 3)
                : "0"
              : "0",
            serv4: props.inmueble
              ? props.inmueble.serviciospublicos
                ? props.inmueble.serviciospublicos.toString().substring(3, 4)
                : "0"
              : "0",
            serv5: props.inmueble
              ? props.inmueble.serviciospublicos
                ? props.inmueble.serviciospublicos.toString().substring(4, 5)
                : "0"
              : "0",
            serv6: props.inmueble
              ? props.inmueble.serviciospublicos
                ? props.inmueble.serviciospublicos.toString().substring(5, 6)
                : "0"
              : "0",
            serv7: props.inmueble
              ? props.inmueble.serviciospublicos
                ? props.inmueble.serviciospublicos.toString().substring(6, 7)
                : "0"
              : "0",
            serv8: props.inmueble
              ? props.inmueble.serviciospublicos
                ? props.inmueble.serviciospublicos.toString().substring(7, 8)
                : "0"
              : "0",
            serv9: props.inmueble
              ? props.inmueble.serviciospublicos
                ? props.inmueble.serviciospublicos.toString().substring(8, 9)
                : "0"
              : "0",
            serv10: props.inmueble
              ? props.inmueble.serviciospublicos
                ? props.inmueble.serviciospublicos.toString().substring(9, 10)
                : "0"
              : "0",
            serv11: props.inmueble
              ? props.inmueble.serviciospublicos
                ? props.inmueble.serviciospublicos.toString().substring(10, 11)
                : "0"
              : "0",
            serv12: props.inmueble
              ? props.inmueble.serviciospublicos
                ? props.inmueble.serviciospublicos.toString().substring(11, 12)
                : "0"
              : "0",
            serv13: props.inmueble
              ? props.inmueble.serviciospublicos
                ? props.inmueble.serviciospublicos.toString().substring(12, 13)
                : "0"
              : "0",
            serv14: props.inmueble
              ? props.inmueble.serviciospublicos
                ? props.inmueble.serviciospublicos.toString().substring(13, 14)
                : "0"
              : "0",
            serv15: props.inmueble
              ? props.inmueble.serviciospublicos
                ? props.inmueble.serviciospublicos.toString().substring(14, 15)
                : "0"
              : "0",
            serv16: props.inmueble
              ? props.inmueble.serviciospublicos
                ? props.inmueble.serviciospublicos.toString().substring(15, 16)
                : "0"
              : "0",
            serv17: props.inmueble
              ? props.inmueble.serviciospublicos
                ? props.inmueble.serviciospublicos.toString().substring(16, 17)
                : "0"
              : "0",
            serv18: props.inmueble
              ? props.inmueble.serviciospublicos
                ? props.inmueble.serviciospublicos.toString().substring(17, 18)
                : "0"
              : "0",
            serv19: props.inmueble
              ? props.inmueble.serviciospublicos
                ? props.inmueble.serviciospublicos.toString().substring(18, 19)
                : "0"
              : "0",
          });

          setCodCatastral({
            cod1: props.inmueble
              ? props.inmueble.codigocatastral
                ? props.inmueble.codigocatastral.substring(0, 2)
                : "0"
              : "0",
            cod2: props.inmueble
              ? props.inmueble.codigocatastral
                ? props.inmueble.codigocatastral.substring(2, 4)
                : "0"
              : "0",
            cod3: props.inmueble
              ? props.inmueble.codigocatastral
                ? props.inmueble.codigocatastral.substring(4, 6)
                : "0"
              : "0",
            cod4: props.inmueble
              ? props.inmueble.codigocatastral
                ? props.inmueble.codigocatastral.substring(6, 7)
                : "U"
              : "U",
            cod5: props.inmueble
              ? props.inmueble.codigocatastral
                ? props.inmueble.codigocatastral.substring(7, 9)
                : "0"
              : "0",
            cod6: props.inmueble
              ? props.inmueble.codigocatastral
                ? props.inmueble.codigocatastral.substring(9, 12)
                : "0"
              : "0",
            cod7: props.inmueble
              ? props.inmueble.codigocatastral
                ? props.inmueble.codigocatastral.substring(12, 15)
                : "0"
              : "0",
            cod8: props.inmueble
              ? props.inmueble.codigocatastral
                ? props.inmueble.codigocatastral.substring(15, 18)
                : "0"
              : "0",
            cod9: props.inmueble
              ? props.inmueble.codigocatastral
                ? props.inmueble.codigocatastral.substring(18, 21)
                : "0"
              : "0",
            cod10: props.inmueble
              ? props.inmueble.codigocatastral
                ? props.inmueble.codigocatastral.substring(21, 24)
                : "0"
              : "0",
            cod11: props.inmueble
              ? props.inmueble.codigocatastral
                ? props.inmueble.codigocatastral.substring(24, 27)
                : "0"
              : "0",
          });
          setTipoPared({
            pared1: props.inmueble
              ? props.inmueble.tipoparedes
                ? props.inmueble.tipoparedes.toString().substring(0, 1)
                : "0"
              : "0",
            pared2: props.inmueble
              ? props.inmueble.tipoparedes
                ? props.inmueble.tipoparedes.toString().substring(1, 2)
                : "0"
              : "0",
            pared3: props.inmueble
              ? props.inmueble.tipoparedes
                ? props.inmueble.tipoparedes.toString().substring(2, 3)
                : "0"
              : "0",
            pared4: props.inmueble
              ? props.inmueble.tipoparedes
                ? props.inmueble.tipoparedes.toString().substring(3, 4)
                : "0"
              : "0",
            pared5: props.inmueble
              ? props.inmueble.tipoparedes
                ? props.inmueble.tipoparedes.toString().substring(4, 5)
                : "0"
              : "0",
            pared6: props.inmueble
              ? props.inmueble.tipoparedes
                ? props.inmueble.tipoparedes.toString().substring(5, 6)
                : "0"
              : "0",
            pared7: props.inmueble
              ? props.inmueble.tipoparedes
                ? props.inmueble.tipoparedes.toString().substring(6, 7)
                : "0"
              : "0",
            pared8: props.inmueble
              ? props.inmueble.tipoparedes
                ? props.inmueble.tipoparedes.toString().substring(7, 8)
                : "0"
              : "0",
            pared9: props.inmueble
              ? props.inmueble.tipoparedes
                ? props.inmueble.tipoparedes.toString().substring(8, 9)
                : "0"
              : "0",
            pared10: props.inmueble
              ? props.inmueble.tipoparedes
                ? props.inmueble.tipoparedes.toString().substring(9, 10)
                : "0"
              : "0",
          });
          datosClasificador(props.inmueble.idclaseterreno);
          seleccionarRegistrosClaseInmu(
            props.inmueble.idclaseinmueble,
            props.inmueble.tipozona,
          );
          setIdinmu(props.inmueble ? props.inmueble.idinmueble : 0);
          buscarCoordenadas(props.inmueble ? props.inmueble.idinmueble : "");
          terrenoConst(props.inmueble ? props.inmueble.idinmueble : 0);
        } else {
          setRecords([]);
        }
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between text-light azulGradiant rounded-top">
        <h3 className="fw-bold m-0">
          {operacion === 1
            ? "Agregar Ficha Catastral."
            : operacion === 2
              ? "Editar Ficha Catastral."
              : operacion === 3
                ? "Eliminar Ficha Catastral."
                : "Consultar Ficha Catastral."}
        </h3>
        <a
          type="button"
          ref={btnCancela}
          className="text-light fw-bold fs-6"
          onClick={cancelar}
        >
          Salir <i className="fas fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <ul
          className="nav mb-3 d-flex justify-content-betwen flex-wrap gap-3"
          id="ex-with-icons"
          role="tablist"
        >
          <li className="nav-item flex-fill" role="presentation">
            <a
              className={activeTab.tab1}
              id="ex-with-icons-tab-1"
              type="button"
              onClick={tabs(1)}
              data-mdb-toggle={tabIndex.tab1}
              role="tab"
              aria-controls="tab1"
              aria-selected={tabvalid.tab1}
            >
              <i className="fas fa-chart-pie fa-fw me-2" />
              Datos Gnr.
            </a>
          </li>
          <li className="nav-item flex-fill" role="presentation">
            <a
              className={activeTab.tab2}
              id="ex-with-icons-tab-2"
              type="button"
              onClick={tabs(2)}
              data-mdb-toggle={tabIndex.tab2}
              role="tab"
              aria-controls="tab2"
              aria-selected={tabvalid.tab2}
            >
              <i className="fas fa-chart-line fa-fw me-2" />
              Otros Datos
            </a>
          </li>

          <li className="nav-item flex-fill" role="presentation">
            <a
              className={activeTab.tab3}
              id="ex-with-icons-tab-3"
              type="button"
              onClick={tabs(3)}
              data-mdb-toggle={tabIndex.tab3}
              role="tab"
              aria-controls="tab3"
              aria-selected={tabvalid.tab3}
            >
              <i className="fas fa-chart-line fa-fw me-2" />
              Dts. del Terreno
            </a>
          </li>

          <li className="nav-item flex-fill" role="presentation">
            <a
              className={activeTab.tab4}
              id="ex-with-icons-tab-4"
              type="button"
              onClick={tabs(4)}
              data-mdb-toggle={tabIndex.tab4}
              role="tab"
              aria-controls="tab4"
              aria-selected={tabvalid.tab4}
            >
              <i className="fas fa-chart-line fa-fw me-2" />
              Dts. de la Construc.
            </a>
          </li>

          <li className="nav-item flex-fill" role="presentation">
            <a
              className={activeTab.tab5}
              id="ex-with-icons-tab-5"
              type="button"
              onClick={tabs(5)}
              data-mdb-toggle={tabIndex.tab5}
              role="tab"
              aria-controls="tab5"
              aria-selected={tabvalid.tab5}
            >
              <i className="fas fa-chart-line fa-fw me-2" />
              Valoración Economi.
            </a>
          </li>

          <li className="nav-item flex-fill" role="presentation">
            <a
              className={activeTab.tab6}
              id="ex-with-icons-tab-6"
              type="button"
              onClick={tabs(6)}
              data-mdb-toggle={tabIndex.tab6}
              role="tab"
              aria-controls="tab6"
              aria-selected={tabvalid.tab6}
            >
              <i className="fas fa-chart-line fa-fw me-2" />
              Ubicación-Cartografia
            </a>
          </li>

          <li className="nav-item flex-fill" role="presentation">
            <a
              className={activeTab.tab7}
              id="ex-with-icons-tab-7"
              type="button"
              onClick={tabs(7)}
              data-mdb-toggle={tabIndex.tab7}
              role="tab"
              aria-controls="tab7"
              aria-selected="false"
            >
              <i className="fas fa-vote-yea fa-fw me-2"></i>Deudas
            </a>
          </li>

          <li className="nav-item" role="presentation">
            <a
              className={activeTab.tab8}
              id="ex-with-icons-tab-8"
              type="button"
              onClick={tabs(8)}
              data-mdb-toggle={tabIndex.tab8}
              role="tab"
              aria-controls="tab8"
              aria-selected="false"
            >
              <i className="fas fa-vote-yea fa-fw me-2"></i> Historicos
            </a>
          </li>
        </ul>
        <div className="tab-content" id="ex-with-icons-content">
          <div
            className={tabPanel.tab1}
            id="tab1"
            role="tabpanel"
            aria-labelledby="ex-with-icons-tab-1"
          >
            <div className="col-12 m-0 p-0 d-flex flex-wrap">
              <div className="col-2 m-0 mb-2 p-0">
                <Input
                  label="Código"
                  disabled
                  value={
                    values
                      ? values.idinmueble !== ""
                        ? values.idinmueble
                        : ""
                      : ""
                  }
                  onKeyUp={handleInputNumChange}
                  onBlur={handleInputNumChange}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Ficha Catastral N°:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={txtNumFicha}
                  onKeyUp={handleInputNumChange}
                  onBlur={handleInputNumChange}
                  value={
                    values
                      ? values.numficha
                        ? values.numficha.trim()
                        : ""
                      : ""
                  }
                  name="numficha"
                  onChange={onChange}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Inscripción Catastral N°:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={txtNumInscrip}
                  onKeyUp={handleInputNumChange}
                  onBlur={handleInputNumChange}
                  value={
                    values
                      ? values.numinscripcion
                        ? values.numinscripcion.trim()
                        : ""
                      : ""
                  }
                  name="numinscripcion"
                  onChange={onChange}
                />
              </div>
              <div className="col-2 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Fecha:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  type="date"
                  ref={txtFechaInscrip}
                  value={
                    values
                      ? values.fechainscripcion !== ""
                        ? moment
                            .utc(values.fechainscripcion)
                            .format("YYYY-MM-DD")
                        : ""
                      : ""
                  }
                  name="fechainscripcion"
                  onChange={onChange}
                />
              </div>
              <div className="col-2 m-0 mb-2 p-0 pl-2">
                <Select
                  label="Status:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  value={values.status}
                  name="status"
                  onChange={onChange}
                >
                  <option value="61">ACTIVO</option>
                  <option value="62">INACTIVO</option>
                  <option value="63">EXCEPCION DE INMUEBLE</option>
                </Select>
              </div>
              <table class="col-12 m-0 p-0 table table-responsive">
                <thead>
                  <tr>
                    <th className="text-center" scope="col">
                      Estado
                    </th>
                    <th className="text-center" scope="col">
                      Municipio
                    </th>
                    <th className="text-center" scope="col">
                      Parroquia
                    </th>
                    <th className="text-center" scope="col">
                      Ambito
                    </th>
                    <th className="text-center" scope="col">
                      Sector
                    </th>
                    <th className="text-center" scope="col">
                      Manz
                    </th>
                    <th className="text-center" scope="col">
                      Parc
                    </th>
                    <th className="text-center" scope="col">
                      SubP.
                    </th>
                    <th className="text-center" scope="col">
                      Nivel.
                    </th>
                    <th className="text-center" scope="col">
                      Unidad.
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        type="text"
                        ref={txtCCEdo}
                        maxLength={2}
                        value={
                          codCatastral.cod1 !== "" ? codCatastral.cod1 : ""
                        }
                        class="form-control form-control-sm text-center"
                        onKeyUp={handleInputNumChange}
                        //onBlur={handleInputNumChange}
                        id="codcatastral"
                        onChange={onChange}
                        name="cod1"
                      />
                    </td>
                    <td>
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        type="text"
                        ref={txtCCMun}
                        maxLength={2}
                        value={
                          codCatastral.cod2 !== "" ? codCatastral.cod2 : ""
                        }
                        class="form-control form-control-sm text-center"
                        onKeyUp={handleInputNumChange}
                        onBlur={handleInputNumChange}
                        id="codcatastral"
                        onChange={onChange}
                        name="cod2"
                      />
                    </td>
                    <td>
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        type="text"
                        ref={txtCCParr}
                        maxLength={2}
                        value={
                          codCatastral.cod3 !== "" ? codCatastral.cod3 : ""
                        }
                        class="form-control form-control-sm text-center"
                        onKeyUp={handleInputNumChange}
                        onBlur={handleInputNumChange}
                        id="codcatastral"
                        onChange={onChange}
                        name="cod3"
                      />
                    </td>
                    <td>
                      <div
                        class="input-group input-group-sm px-0 m-0 row"
                        style={{ width: 95 }}
                      >
                        <select
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          class="form-select col-md-7 px-1"
                          ref={cmbCCAm}
                          value={
                            codCatastral.cod4 !== ""
                              ? codCatastral.cod4.trim()
                              : ""
                          }
                          id="codcatastral"
                          onChange={onChange}
                          name="cod4"
                        >
                          <option value="U">U</option>
                          <option value="R">R</option>
                        </select>
                        <input
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="text"
                          ref={txtCCAm}
                          maxLength={2}
                          value={
                            codCatastral.cod5 !== "" ? codCatastral.cod5 : ""
                          }
                          class="form-control col text-center"
                          
                          id="codcatastral"
                          onChange={onChange}
                          name="cod5"
                        />
                      </div>
                    </td>
                    <td>
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        type="text"
                        ref={txtCCSect}
                        maxLength={3}
                        value={
                          codCatastral.cod6 !== "" ? codCatastral.cod6 : ""
                        }
                        class="form-control form-control-sm text-center"
                       
                        id="codcatastral"
                        onChange={onChange}
                        name="cod6"
                      />
                    </td>
                    <td>
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        type="text"
                        ref={txtCCManz}
                        maxLength={3}
                        value={
                          codCatastral.cod7 !== "" ? codCatastral.cod7 : ""
                        }
                        class="form-control form-control-sm text-center"
                       
                        id="codcatastral"
                        onChange={onChange}
                        name="cod7"
                      />
                    </td>
                    <td>
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        type="text"
                        ref={txtCCParc}
                        maxLength={3}
                        value={
                          codCatastral.cod8 !== "" ? codCatastral.cod8 : ""
                        }
                        class="form-control form-control-sm text-center"
                        id="codcatastral"
                        onChange={onChange}
                        name="cod8"
                      />
                    </td>
                    <td>
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        type="text"
                        maxLength={3}
                        value={
                          codCatastral.cod9 !== "" ? codCatastral.cod9 : ""
                        }
                        class="form-control form-control-sm text-center"
                        id="codcatastral"
                        onChange={onChange}
                        name="cod9"
                      />
                    </td>
                    <td>
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        type="text"
                        ref={txtCCNiv}
                        maxLength={3}
                        value={
                          codCatastral.cod10 !== "" ? codCatastral.cod10 : ""
                        }
                        class="form-control form-control-sm text-center"
                        id="codcatastral"
                        onChange={onChange}
                        name="cod10"
                      />
                    </td>
                    <td>
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        type="text"
                        ref={txtCCUni}
                        maxLength={3}
                        value={
                          codCatastral.cod11 !== "" ? codCatastral.cod11 : ""
                        }
                        class="form-control form-control-sm text-center"
                        id="codcatastral"
                        onChange={onChange}
                        name="cod11"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <fieldset className="col-12 m-0 p-2 d-flex align-items-center justify-content-between flex-wrap border-azul rounded">
                <legend className="float-none w-auto">
                  Dirección del Inmueble
                </legend>
                <div className="col-6 m-0 mb-2 p-0">
                  <Input
                    label="Nombre de Parroquia:"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtNomParr}
                    value={
                      values && values.parroquia !== "" ? values.parroquia : ""
                    }
                    name="parroquia"
                    onChange={onChange}
                  />
                </div>
                <div className="col-6 m-0 mb-2 p-0 pl-2 d-flex">
                  <div className="col-6 m-0 p-0">
                    <Select
                      label="Ciudad/Comunidad"
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      ref={cmbDir6}
                      value={
                        values && values.dirinmue6
                          ? values.dirinmue6 !== ""
                            ? values.dirinmue6.trim()
                            : ""
                          : ""
                      }
                      name="dirinmue6"
                      onChange={onChange}
                    >
                      <option value="">--</option>
                      <option value="CIUDAD">CIUDAD</option>
                      <option value="COMUNIDAD">COMUNIDAD</option>
                      <option value="CASERIO">CASERIO</option>
                    </Select>
                  </div>
                  <Input
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtDir6}
                    value={
                      values && values.descridirinmue6
                        ? values.descridirinmue6 !== ""
                          ? values.descridirinmue6
                          : ""
                        : ""
                    }
                    name="descridirinmue6"
                    onChange={onChange}
                  />
                </div>
                <div className="col-6 m-0 mb-2 p-0 d-flex">
                  <div className="col-6 m-0 p-0">
                    <Select
                      label="Barrio/Sector/Urb"
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      ref={cmbDir1}
                      value={
                        values && values.dirinmue1
                          ? values.dirinmue1.trim()
                          : ""
                      }
                      name="dirinmue1"
                      onChange={onChange}
                    >
                      <option value="">--</option>
                      <option value="CIUDAD">CIUDAD</option>
                      <option value="COMUNIDAD">COMUNIDAD</option>
                      <option value="URBANIZACION">URBANIZACION</option>
                      <option value="CONJ. RESIDENCIAL">
                        CONJ. RESIDENCIAL
                      </option>
                      <option value="BARRIO">BARRIO</option>
                      <option value="SECTOR">SECTOR</option>
                      <option value="CASERIO">CASERIO</option>
                      <option value="EEDIFICIO">EEDIFICIO</option>
                      <option value="CENTRO COMERCIAL">CENTRO COMERCIAL</option>
                      <option value="MANZANA">MANZANA</option>
                      <option value="PARCELAMIENTO">PARCELAMIENTO</option>
                    </Select>
                  </div>
                  <Input
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtDir1}
                    value={
                      values
                        ? values.descridirinmue1 !== ""
                          ? values.descridirinmue1
                          : ""
                        : ""
                    }
                    name="descridirinmue1"
                    onChange={onChange}
                  />
                </div>
                <div className="col-6 m-0 mb-2 p-0 pl-2 d-flex">
                  <div className="col-6 m-0 p-0">
                    <Select
                      label="Av/Calle:"
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      ref={cmbDir2}
                      value={values && values.dirinmue2?.trim()}
                      name="dirinmue2"
                      onChange={onChange}
                    >
                      <option value="">--</option>
                      <option value="AVENIDA">AVENIDA</option>
                      <option value="CALLE">CALLE</option>
                      <option value="CARRERA">CARRERA</option>
                      <option value="TRANSVERSAL">TRANSVERSAL</option>
                      <option value="PROLONGACION">PROLONGACION</option>
                      <option value="CARRETERA">CARRETERA</option>
                      <option value="CALLEJON">CALLEJON</option>
                      <option value="PASAJE">PASAJE</option>
                      <option value="BOULEVARD">BOULEVARD</option>
                      <option value="VEREDA">VEREDA</option>
                      <option value="ESCALERA">ESCALERA</option>
                      <option value="CONJUNTO">CONJUNTO</option>
                      <option value="TRONCAL">TRONCAL</option>
                      <option value="CAMINO">CAMINO</option>
                      <option value="SECTOR">SECTOR</option>
                      <option value="MANZANA">MANZANA</option>
                    </Select>
                  </div>
                  <Input
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtDir2}
                    value={
                      values
                        ? values.descridirinmue2 !== ""
                          ? values.descridirinmue2
                          : ""
                        : ""
                    }
                    name="descridirinmue2"
                    onChange={onChange}
                  />
                </div>
                <div className="col-6 m-0 mb-2 p-0 d-flex">
                  <div className="col-6 m-0 p-0">
                    <Select
                      label="Entre Av./Calle:"
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      ref={cmbDir3}
                      value={values.dirinmue3 ? values.dirinmue3.trim() : ""}
                      name="dirinmue3"
                      onChange={onChange}
                    >
                      <option value="">--</option>
                      <option value="AVENIDA">AVENIDA</option>
                      <option value="CALLE">CALLE</option>
                      <option value="CARRERA">CARRERA</option>
                      <option value="TRANSVERSAL">TRANSVERSAL</option>
                      <option value="PROLONGACION">PROLONGACION</option>
                      <option value="CARRETERA">CARRETERA</option>
                      <option value="CALLEJON">CALLEJON</option>
                      <option value="PASAJE">PASAJE</option>
                      <option value="BOULEVARD">BOULEVARD</option>
                      <option value="VEREDA">VEREDA</option>
                      <option value="ESCALERA">ESCALERA</option>
                      <option value="CONJUNTO">CONJUNTO</option>
                      <option value="TRONCAL">TRONCAL</option>
                      <option value="SECTOR">SECTOR</option>
                      <option value="MANZANA">MANZANA</option>
                    </Select>
                  </div>
                  <Input
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtDir3}
                    value={
                      values && values.descridirinmue3
                        ? values.descridirinmue3 !== ""
                          ? values.descridirinmue3
                          : ""
                        : ""
                    }
                    name="descridirinmue3"
                    onChange={onChange}
                  />
                </div>
                <div className="col-6 m-0 mb-2 p-0 pl-2 d-flex">
                  <div className="col-6 m-0 p-0">
                    <Select
                      label="Y Av./CalleVda:"
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      ref={cmbDir4}
                      value={
                        values && values.dirinmue4
                          ? values.dirinmue4 !== ""
                            ? values.dirinmue4.trim()
                            : ""
                          : ""
                      }
                      name="dirinmue4"
                      onChange={onChange}
                    >
                      <option value="">--</option>
                      <option value="AVENIDA">AVENIDA</option>
                      <option value="CALLE">CALLE</option>
                      <option value="CARRERA">CARRERA</option>
                      <option value="TRAVERSAL">TRAVERSAL</option>
                      <option value="PROLONGACION">PROLONGACION</option>
                      <option value="CARRETERA">CARRETERA</option>
                      <option value="CALLEJON">CALLEJON</option>
                      <option value="PASAJE">PASAJE</option>
                      <option value="BOULEVARD">BOULEVARD</option>
                      <option value="VEREDA">VEREDA</option>
                      <option value="ESCALERA">ESCALERA</option>
                      <option value="CONJUNTO">CONJUNTO</option>
                      <option value="TRONCAL">TRONCAL</option>
                      <option value="CAMINO">CAMINO</option>
                    </Select>
                  </div>
                  <Input
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtDir4}
                    value={
                      values && values.descridirinmue4
                        ? values.descridirinmue4
                        : ""
                    }
                    name="descridirinmue4"
                    onChange={onChange}
                  />
                </div>
                <div className="col-6 m-0 mb-2 p-0 d-flex">
                  <div className="col-6 m-0 p-0">
                    <Select
                      label="Casa/Apto:"
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      ref={cmbDir5}
                      value={
                        values && values.dirinmue5
                          ? values.dirinmue5.trim()
                          : ""
                      }
                      name="dirinmue5"
                      onChange={onChange}
                    >
                      <option value="">--</option>
                      <option value="EDIFICIO">EDIFICIO</option>
                      <option value="APARTAMENTO">APARTAMENTO</option>
                      <option value="QUINTA">QUINTA</option>
                      <option value="CASA">CASA</option>
                      <option value="RANCHO">RANCHO</option>
                      <option value="CENTRO COMERCIAL">CENTRO COMERCIAL</option>
                      <option value="LOCAL COMERCIAL">LOCAL COMERCIAL</option>
                      <option value="OFICINA">OFICINA</option>
                      <option value="GALPON">GALPON</option>
                      <option value="INSTITUCION">INSTITUCION</option>
                      <option value="PARCELA">PARCELA</option>
                      <option value="HOTAL">HOTAL</option>
                    </Select>
                  </div>
                  <Input
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtDir5}
                    value={
                      values && values.descridirinmue5
                        ? values.descridirinmue5
                        : ""
                    }
                    name="descridirinmue5"
                    onChange={onChange}
                  />
                </div>
                <div className="col-6 m-0 p-0 pl-2">
                  <Input
                    label="N° Civico:"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtNCInm}
                    value={
                      values && values.numcivicoinmue
                        ? values && values.numcivicoinmue
                        : ""
                    }
                    name="numcivicoinmue"
                    onChange={onChange}
                  />
                </div>
                <div className="col-6 m-0 p-0">
                  <Input
                    label="Telefono:"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtTlfInm}
                    value={
                      values && values.telefonoinmue
                        ? values.telefonoinmue.trim()
                        : ""
                    }
                    name="telefonoinmue"
                    onChange={onChange}
                  />
                </div>
                <div className="col-6 m-0 p-0 pl-2">
                  <Input
                    label="Punto de Referencia:"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtPRInm}
                    value={
                      values && values.ptoreferenciainmue
                        ? values.ptoreferenciainmue
                        : ""
                    }
                    name="ptoreferenciainmue"
                    onChange={onChange}
                  />
                </div>
              </fieldset>
              <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex flex-wrap justify-content-between">
                <legend className="float-none w-auto">
                  Datos del Ocupante
                </legend>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input
                    label="Apellidos y Nombre/Razón Social:"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtNomOcupante}
                    value={
                      values && values.nombreocupante
                        ? values.nombreocupante
                        : ""
                    }
                    name="nombreocupante"
                    onChange={onChange}
                  />
                </div>
                <div className="col-12 col-lg-2 m-0 mb-2 p-0">
                  <Select
                    label="Persona:"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={cmbPerOcupante}
                    value={
                      values && values.tipoperocupante
                        ? values.tipoperocupante
                        : "0"
                    }
                    name="tipoperocupante"
                    onChange={onChange}
                  >
                    <option value="0"></option>
                    <option value="1">Natural</option>
                    <option value="2">Juridica</option>
                  </Select>
                </div>
                <div className="col-12 col-lg-10 p-0 pl-lg-2 m-0 mb-2">
                  <Input
                    label="Cedula/Rif:"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtRifOcupante}
                    value={
                      values && values.cedulaocupante
                        ? values.cedulaocupante
                        : ""
                    }
                    name="cedulaocupante"
                    onChange={onChange}
                  />
                </div>
                <div className="col-12 col-lg-6 m-0 mb-2 p-0 pr-lg-2">
                  <Input
                    label="Ciudad/Localidad:"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtCidOcupante}
                    value={
                      values && values.ciudadocupante
                        ? values.ciudadocupante
                        : ""
                    }
                    name="ciudadocupante"
                    onChange={onChange}
                  />
                </div>
                <div className="col-12 col-lg-6 m-0 mb-2 p-0">
                  <Select
                    label="Urb/Barrio/Sect:"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={cmbUrbOcupante}
                    value={
                      values && values.urbocupante
                        ? values.urbocupante.trim()
                        : ""
                    }
                    name="urbocupante"
                    onChange={onChange}
                  >
                    <option value="">--</option>
                    <option value="CIUDAD">CIUDAD</option>
                    <option value="COMUNIDAD">COMUNIDAD</option>
                    <option value="CONJ. RESIDENCIAL">CONJ. RESIDENCIAL</option>
                    <option value="BARRIO">BARRIO</option>
                    <option value="SECTOR">SECTOR</option>
                    <option value="CASERIO">CASERIO</option>
                    <option value="EDIFICIO">EDIFICIO</option>
                    <option value="CENTRO COMERCIAL">CENTRO COMERCIAL</option>
                    <option value="MANZANA">MANZANA</option>
                    <option value="PARCELAMIENTO">PARCELAMIENTO</option>
                  </Select>
                </div>
                <div className="col-12 col-lg-6 m-0 mb-2 p-0 pr-lg-2">
                  <Input
                    label={
                      "Nombre de:" +
                      (values && values.urbocupante ? values.urbocupante : "")
                    }
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtUrbOcupante}
                    value={
                      values && values.nomurbocupante
                        ? values.nomurbocupante.trim()
                        : ""
                    }
                    name="nomurbocupante"
                    onChange={onChange}
                  />
                </div>
              </fieldset>
            </div>
          </div>
          <div
            className={tabPanel.tab2}
            id="tab2"
            role="tabpanel"
            aria-labelledby="ex-with-icons-tab-2"
          >
            <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex flex-wrap justify-content-between align-items-center">
              <legend className="float-none w-auto m-0">
                Dirección del Propietario/ Rep. Legal/ Administrador
              </legend>
              <div className="col-12 m-0 mb-2 p-0">
                <Input
                  label="Apellidos y Nombres/Razon Social:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={txtNomPropietario}
                  value={values.nombrepropie !== "" ? values.nombrepropie : ""}
                  name="nombrepropie"
                  onChange={onChange}
                />
              </div>
              <div className="col-12 col-lg-2 m-0 mb-2 p-0">
                <Select
                  label="Persona:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={cmbPerPropietario}
                  value={
                    values.tipoperpropie !== "" ? values.tipoperpropie : "0"
                  }
                  name="tipoperpropie"
                  onChange={onChange}
                >
                  <option value="0">--</option>
                  <option value="1">Natural</option>
                  <option value="2">Juridica</option>
                </Select>
              </div>
              <div className="col-12 col-lg-2 m-0 mb-2 p-0 pl-lg-2">
                <Input
                  label="Cedula/Rif:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={txtRifPropietario}
                  value={values.cedulapropie !== "" ? values.cedulapropie : ""}
                  name="cedulapropie"
                  onChange={onChange}
                />
              </div>
              <div className="col-12 col-lg-4 m-0 mb-2 p-0">
                <Input
                  label="Ciudad/Localidad:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={txtCidPorpietario}
                  value={
                    values && values.ciudadpropie
                      ? values.ciudadpropie.trim()
                      : ""
                  }
                  name="ciudadpropie"
                  onChange={onChange}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0">
                <Select
                  label="Propie/Rep. Legal:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={cmbProRepLeg}
                  value={values && values.tipopropie.trim()}
                  name="tipopropie"
                  onChange={onChange}
                >
                  <option value="">--</option>
                  <option value="PROPIETARIO">PROPIETARIO</option>
                  <option value="REP. LEGAL">REP. LEGAL</option>
                  <option value="ADMINISTRADOR">ADMINISTRADOR</option>
                </Select>
              </div>
              <div className="col-6 m-0 mb-2 p-0 d-flex">
                <div className="col-6 m-0 p-0">
                  <Select
                    label="Barrio/Sector/Urb:"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={cmbDirPro1}
                    value={
                      values && values.dirpropie1
                        ? values.dirpropie1.trim()
                        : ""
                    }
                    name="dirpropie1"
                    onChange={onChange}
                  >
                    <option value="">--</option>
                    <option value="CIUDAD">CIUDAD</option>
                    <option value="COMUNIDAD">COMUNIDAD</option>
                    <option value="URBANIZACION">URBANIZACION</option>
                    <option value="CONJ. RESIDENCIAL">CONJ. RESIDENCIAL</option>
                    <option value="BARRIO">BARRIO</option>
                    <option value="SECTOR">SECTOR</option>
                    <option value="CASERIO">CASERIO</option>
                    <option value="EEDIFICIO">EEDIFICIO</option>
                    <option value="CENTRO COMERCIAL">CENTRO COMERCIAL</option>
                    <option value="MANZANA">MANZANA</option>
                    <option value="PARCELAMIENTO">PARCELAMIENTO</option>
                  </Select>
                </div>
                <Input
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={txtDirPro1}
                  value={
                    values && values.descridirpropie1
                      ? values.descridirpropie1
                      : ""
                  }
                  name="descridirpropie1"
                  onChange={onChange}
                />
              </div>
              <div className="col-6 m-0 mb-2 p-0 pl-2 d-flex">
                <div className="col-6 m-0 p-0">
                  <Select
                    label="Av/Calle:"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={cmbDirPro2}
                    value={
                      values && values.dirpropie2
                        ? values.dirpropie2.trim()
                        : ""
                    }
                    name="dirpropie2"
                    onChange={onChange}
                  >
                    <option value="">--</option>
                    <option value="AVENIDA">AVENIDA</option>
                    <option value="CALLE">CALLE</option>
                    <option value="CARRERA">CARRERA</option>
                    <option value="TRANSVERSAL">TRANSVERSAL</option>
                    <option value="PROLONGACION">PROLONGACION</option>
                    <option value="CARRETERA">CARRETERA</option>
                    <option value="CALLEJON">CALLEJON</option>
                    <option value="PASAJE">PASAJE</option>
                    <option value="BOULEVARD">BOULEVARD</option>
                    <option value="VEREDA">VEREDA</option>
                    <option value="ESCALERA">ESCALERA</option>
                    <option value="CONJUNTO">CONJUNTO</option>
                    <option value="TRONCAL">TRONCAL</option>
                    <option value="CAMINO">CAMINO</option>
                    <option value="SECTOR">SECTOR</option>
                    <option value="MANZANA">MANZANA</option>
                  </Select>
                </div>
                <Input
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={txtDirPro2}
                  value={
                    values && values.descridirpropie2
                      ? values.descridirpropie2
                      : ""
                  }
                  name="descridirpropie2"
                  onChange={onChange}
                />
              </div>
              <div className="col-6 m-0 mb-2 p-0 d-flex">
                <div className="col-6 m-0 p-0">
                  <Select
                    label="Entre Av./Calle:"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={cmbDirPro3}
                    value={
                      values && values.dirpropie3
                        ? values.dirpropie3.trim()
                        : ""
                    }
                    name="dirpropie3"
                    onChange={onChange}
                  >
                    <option value="">--</option>
                    <option value="AVENIDA">AVENIDA</option>
                    <option value="CALLE">CALLE</option>
                    <option value="CARRERA">CARRERA</option>
                    <option value="TRANSVERSAL">TRANSVERSAL</option>
                    <option value="PROLONGACION">PROLONGACION</option>
                    <option value="CARRETERA">CARRETERA</option>
                    <option value="CALLEJON">CALLEJON</option>
                    <option value="PASAJE">PASAJE</option>
                    <option value="BOULEVARD">BOULEVARD</option>
                    <option value="VEREDA">VEREDA</option>
                    <option value="ESCALERA">ESCALERA</option>
                    <option value="CONJUNTO">CONJUNTO</option>
                    <option value="TRONCAL">TRONCAL</option>
                    <option value="SECTOR">SECTOR</option>
                    <option value="MANZANA">MANZANA</option>
                  </Select>
                </div>
                <Input
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={txtDirPro3}
                  value={
                    values && values.descridirpropie3
                      ? values.descridirpropie3
                      : ""
                  }
                  name="descridirpropie3"
                  onChange={onChange}
                />
              </div>
              <div className="col-6 m-0 mb-2 p-0 pl-2 d-flex">
                <div className="col-6 m-0 p-0">
                  <Select
                    label="Y Av./CalleVda"
                    ref={cmbDirPro4}
                    value={
                      values && values.dirpropie4
                        ? values.dirpropie4.trim()
                        : ""
                    }
                    name="dirpropie4"
                    onChange={onChange}
                  >
                    <option value="">--</option>
                    <option value="AVENIDA">AVENIDA</option>
                    <option value="CALLE">CALLE</option>
                    <option value="CARRETERA">CARRETERA</option>
                    <option value="TRAVERSAL">TRAVERSAL</option>
                    <option value="PROLONGACION">PROLONGACION</option>
                    <option value="CARRETERA">CARRETERA</option>
                    <option value="CALLEJON">CALLEJON</option>
                    <option value="PASAJE">PASAJE</option>
                    <option value="BOULEVARD">BOULEVARD</option>
                    <option value="VEREDA">VEREDA</option>
                    <option value="CONJUNTO">CONJUNTO</option>
                    <option value="TRONCAL">TRONCAL</option>
                    <option value="ESCALERA">ESCALERA</option>
                    <option value="CAMINO">CAMINO</option>
                  </Select>
                </div>
                <Input
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={txtDirPro4}
                  value={
                    values && values.descridirpropie4
                      ? values.descridirpropie4
                      : ""
                  }
                  onChange={onChange}
                  name="descridirpropie4"
                />
              </div>
              <div className="col-6 m-0 mb-2 p-0 d-flex">
                <div className="col-6 m-0 p-0">
                  <Select
                    label="Casa/Apto:"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={cmbDirPro5}
                    value={
                      values && values.dirpropie5
                        ? values.dirpropie5.trim()
                        : ""
                    }
                    name="dirpropie5"
                    onChange={onChange}
                  >
                    <option value="">--</option>
                    <option value="EDIFICIO">EDIFICIO</option>
                    <option value="APARTAMENTO">APARTAMENTO</option>
                    <option value="QUINTA">QUINTA</option>
                    <option value="CASA">CASA</option>
                    <option value="RANCHO">RANCHO</option>
                    <option value="CENTRO COMERCIAL">CENTRO COMERCIAL</option>
                    <option value="LOCAL COMERCIAL">LOCAL COMERCIAL</option>
                    <option value="OFICINA">OFICINA</option>
                    <option value="GALPON">GALPON</option>
                    <option value="INSTITUCION">INSTITUCION</option>
                    <option value="PARCELA">PARCELA</option>
                    <option value="HOTAL">HOTAL</option>
                  </Select>
                </div>
                <Input
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={txtDirPro5}
                  value={
                    values && values.descridirpropie5
                      ? values.descridirpropie5
                      : ""
                  }
                  name="descridirpropie5"
                  onChange={onChange}
                />
              </div>
              <div className="col-6 m-0 mb-2 p-0 pl-2">
                <Input
                  label="N° Civico:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={txtNCOcupante}
                  value={
                    values && values.numcivicopropie
                      ? values.numcivicopropie
                      : ""
                  }
                  name="numcivicopropie"
                  onChange={onChange}
                />
              </div>
              <div className="col-6 m-0 mb-2 p-0">
                <Input
                  label="Telefono:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={txtTlfPropietario}
                  value={
                    values && values.telefonopropie ? values.telefonopropie : ""
                  }
                  name="telefonopropie"
                  onChange={onChange}
                />
              </div>
              <div className="col-6 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Punto de Referencia:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={txtPRPropietario}
                  value={
                    values && values.ptoreferenciapropie
                      ? values.ptoreferenciapropie
                      : ""
                  }
                  name="ptoreferenciapropie"
                  onChange={onChange}
                />
              </div>
              <fieldset className="col-12 m-0 p-2 border-azul rounded">
                <legend className="float-none w-auto m-0">
                  Clasificación de Zona Dentro de las Áreas Urbanas y
                  Periurbanas
                </legend>
                <div className="col-4 m-0 mb-2 p-0">
                  <Select
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={cmbTipoZona}
                    value={values.tipozona ? values.tipozona : ""}
                    name="tipozona"
                    onChange={onChange}
                  >
                    {/* <option value=" "> </option> */}
                    {tipoZonas &&
                      tipoZonas.map((sta) => (
                        <option key={sta.idzonainmueble} value={sta.tipo}>
                          {"Zona de Tipo " + sta.tipo.trim()}
                        </option>
                      ))}
                  </Select>
                </div>
                <Textarea
                  //ref={txtTipoCaracter}
                  value={txtTipoCaracter}
                  style={{ height: 70 }}
                  disabled
                />
              </fieldset>
            </fieldset>
          </div>
          <div
            className={tabPanel.tab3}
            id="tab3"
            role="tabpanel"
            aria-labelledby="ex-with-icons-tab-3"
          >
            <fieldset className="col-12 m-0 p-02 d-flex flex-wrap align-items-center border-azul rounded">
              <legend className="float-none w-auto m-0">
                Datos del Terreno
              </legend>
              <div className="col-4 m-0 mb-2 p-0">
                <Select
                  label="1-Topografia:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={cmbTopografia}
                  value={
                    values && values.topografiaterreno
                      ? values.topografiaterreno.trim()
                      : ""
                  }
                  name="topografiaterreno"
                  onChange={onChange}
                >
                  <option value="">--</option>
                  <option value="PLANO">PLANO</option>
                  <option value="SOBRE NIVEL">SOBRE NIVEL</option>
                  <option value="BAJO NIVEL">BAJO NIVEL</option>
                  <option value="CORTE">CORTE</option>
                  <option value="RELLENO">RELLENO</option>
                  <option value="INCLINADO">INCLINADO</option>
                  <option value="IRREGULAR">IRREGULAR</option>
                </Select>
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Select
                  label="2-Acceso:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={cmbAccTerr}
                  value={values && values.accesoterreno.trim()}
                  name="accesoterreno"
                  onChange={onChange}
                >
                  <option value="">--</option>
                  <option value="CALLE PAVIMENTADA">CALLE PAVIMENTADA</option>
                  <option value="CALLE ENGRANZONADA">CALLE ENGRANZONADA</option>
                  <option value="CALLE DE TIERRA">CALLE DE TIERRA</option>
                  <option value="ESCALERA DE PAVIMENTO">
                    ESCALERA DE PAVIMENTO
                  </option>
                  <option value="ESCALERA DE TIERRA">ESCALERA DE TIERRA</option>
                </Select>
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Select
                  label="3-Forma:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={cmbForma}
                  value={values && values.formaterreno.trim()}
                  name="formaterreno"
                  onChange={onChange}
                >
                  <option value="">--</option>
                  <option value="REGULAR">REGULAR</option>
                  <option value="IRREGULAR">IRREGULAR</option>
                  <option value="MUY IRREGULAR">MUY IRREGULAR</option>
                </Select>
              </div>
              <div className="col-4 m-0 mb-2 p-0">
                <Select
                  label="4-Ubicación:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={cmbUbiTerr}
                  value={values && values.ubicacionterreno && values.ubicacionterreno.trim()}
                  name="ubicacionterreno"
                  onChange={onChange}
                >
                  <option value="">--</option>
                  <option value="CONVENCIONAL">CONVENCIONAL</option>
                  <option value="ESQUINA">ESQUINA</option>
                  <option value="INTERIOR MANZANA">INTERIOR MANZANA</option>
                </Select>
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Select
                  label="5-Entorno Fisico:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={cmbEntorFisco}
                  value={values && values.entornoterreno && values.entornoterreno.trim()}
                  name="entornoterreno"
                  onChange={onChange}
                >
                  <option value="">--</option>
                  <option value="ZONA URBANIZADA">ZONA URBANIZADA</option>
                  <option value="ZONA NO URBANIZADA">ZONA NO URBANIZADA</option>
                  <option value="RIO/QUEBRADA">RIO/QUEBRADA</option>
                  <option value="BARRANCO/TALUD">BARRANCO/TALUD</option>
                </Select>
              </div>
              <fieldset className="col-12 m-0 mb-2 p-2 d-flex flex-wrap gap-2 border-azul rounded">
                <legend className="float-none w-auto fs-5 m-0">
                  6-Mejoras al Terreno
                </legend>
                <div className="col-auto m-0 p-0">
                  <Checkbox
                    label="Muro de Contención"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    id="mejoras"
                    onChange={checked}
                    name="mej1"
                    checked={
                      mejorasterreno.mej1.toString() === "1" ? true : false
                    }
                  />
                </div>
                <div className="col-auto m-0 p-0">
                  <Checkbox
                    label="Nivelacion"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    id="mejoras"
                    onChange={checked}
                    name="mej2"
                    checked={
                      mejorasterreno.mej2.toString() === "1" ? true : false
                    }
                  />
                </div>
                <div className="col-auto m-0 p-0">
                  <Checkbox
                    label="Cercado"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    id="mejoras"
                    onChange={checked}
                    name="mej3"
                    checked={
                      mejorasterreno.mej3.toString() === "1" ? true : false
                    }
                  />
                </div>
                <div className="col-auto m-0 p-0">
                  <Checkbox
                    label="Pozo Séptico"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    id="mejoras"
                    onChange={checked}
                    name="mej4"
                    checked={
                      mejorasterreno.mej4.toString() === "1" ? true : false
                    }
                  />
                </div>
                <div className="col-auto m-0 p-0">
                  <Checkbox
                    label="Lagunas Artificiales"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    id="mejoras"
                    onChange={checked}
                    name="mej5"
                    checked={
                      mejorasterreno.mej5.toString() === "1" ? true : false
                    }
                  />
                </div>
              </fieldset>
              <div className="col-4 m-0 mb-2 p-0">
                <Select
                  label="7-Tenencia del Terr:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={cmbTenTerr}
                  value={
                    values && values.tenenciaterreno
                      ? values.tenenciaterreno.trim()
                      : ""
                  }
                  name="tenenciaterreno"
                  onChange={onChange}
                >
                  <option value="">--</option>
                  <option value="PROPIEDAD">PROPIEDAD</option>
                  <option value="ARRENDAMIENTO">ARRENDAMIENTO</option>
                  <option value="COMODATO">COMODATO</option>
                  <option value="ANTICRESIS">ANTICRESIS</option>
                  <option value="USUFRUCTUS">USUFRUCTUS</option>
                  <option value="DERECHO USO">DERECHO USO</option>
                  <option value="DERECHO HABITACION">DERECHO HABITACION</option>
                </Select>
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Select
                  label="8-Reg. Propiedad"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={cmbRegPro}
                  value={
                    values && values.regpropieterreno
                      ? values.regpropieterreno.trim()
                      : ""
                  }
                  name="regpropieterreno"
                  onChange={onChange}
                >
                  <option value="">--</option>
                  <option value="EJIDO-MUNICIPAL">EJIDO-MUNICIPAL</option>
                  <option value="MUNICIPAL">MUNICIPAL</option>
                  <option value="MUNICIPAL-PROPIO">MUNICIPAL-PROPIO</option>
                  <option value="NACIONAL">NACIONAL</option>
                  <option value="BALDIO">BALDIO</option>
                  <option value="ESTADAL">ESTADAL</option>
                  <option value="PRIVADO INDIVIDUAL">PRIVADO INDIVIDUAL</option>
                  <option value="PRIVADO CONDOMINIO">PRIVADO CONDOMINIO</option>
                  <option value="BANAVIH">BANAVIH</option>
                  <option value="INTI">INTI</option>
                </Select>
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Select
                  label="9-Uso Actual"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={cmbUsoActu}
                  value={
                    values && values.usoterreno ? values.usoterreno.trim() : ""
                  }
                  name="usoterreno"
                  onChange={onChange}
                >
                  <option value="">--</option>
                  <option value="RESIDENCIAL">RESIDENCIAL</option>
                  <option value="COMERCIAL">COMERCIAL</option>
                  <option value="INDUSTRIAL">INDUSTRIAL</option>
                  <option value="RECREA./DEPORTIV">RECREA./DEPORTIV</option>
                  <option value="ASISTENCIAL/SALUD">ASISTENCIAL/SALUD</option>
                  <option value="EDUCACIONAL">EDUCACIONAL</option>
                  <option value="TURISTICO">TURISTICO</option>
                  <option value="SOCIAL/CULTURAL">SOCIAL/CULTURAL</option>
                  <option value="GUBERN./INSTITUT.">GUBERN./INSTITUT.</option>
                  <option value="RELIGIOSO">RELIGIOSO</option>
                  <option value="PESQUERO">PESQUERO</option>
                  <option value="AGROINDUSTRIAL">AGROINDUSTRIAL</option>
                  <option value="AGROFORESTAL">AGROFORESTAL</option>
                  <option value="AGRICOLA">AGRICOLA</option>
                  <option value="PECUARIO">PECUARIO</option>
                  <option value="FORESTAL">FORESTAL</option>
                  <option value="MINERO">MINERO</option>
                  <option value="SIN USO">SIN USO</option>
                </Select>
              </div>
              <fieldset className="col-12 p-2 m-0 d-flex flex-wrap border-azul rounded">
                <legend className="float-none w-auto fs-5 m-0">
                  10-Servicios Públicos
                </legend>
                <div className="col-12 mx-auto d-flex flex-wrap align-items-start">
                  <div className="form-check mx-auto col-6 col-lg-3">
                    <input
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="servicios"
                      onChange={checked}
                      name="serv1"
                      checked={
                        servPublic.serv1.toString() === "1" ? true : false
                      }
                    />
                    <label className="form-check-label">Acueducto</label>
                  </div>
                  <div className="form-check mx-auto col-6 col-lg-3">
                    <input
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="servicios"
                      onChange={checked}
                      name="serv2"
                      checked={
                        servPublic.serv2.toString() === "1" ? true : false
                      }
                    />
                    <label className="form-check-label">Cloacas</label>
                  </div>
                  <div className="form-check mx-auto col-6 col-lg-3">
                    <input
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="servicios"
                      onChange={checked}
                      name="serv3"
                      checked={
                        servPublic.serv3.toString() === "1" ? true : false
                      }
                    />
                    <label className="form-check-label">Drenaje Articial</label>
                  </div>
                  <div className="form-check mx-auto col-6 col-lg-3">
                    <input
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="servicios"
                      onChange={checked}
                      name="serv4"
                      checked={
                        servPublic.serv4.toString() === "1" ? true : false
                      }
                    />
                    <label className="form-check-label">
                      Eléct. Residencial
                    </label>
                  </div>
                  <div className="form-check mx-auto col-6 col-lg-3">
                    <input
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="servicios"
                      onChange={checked}
                      name="serv5"
                      checked={
                        servPublic.serv5.toString() === "1" ? true : false
                      }
                    />
                    <label className="form-check-label">
                      Eléct. Industrial
                    </label>
                  </div>
                  <div className="form-check mx-auto col-6 col-lg-3">
                    <input
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="servicios"
                      onChange={checked}
                      name="serv6"
                      checked={
                        servPublic.serv6.toString() === "1" ? true : false
                      }
                    />
                    <label className="form-check-label">
                      Alumbrado Publico
                    </label>
                  </div>
                  <div className="form-check mx-auto col-6 col-lg-3">
                    <input
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="servicios"
                      onChange={checked}
                      name="serv7"
                      checked={
                        servPublic.serv7.toString() === "1" ? true : false
                      }
                    />
                    <label className="form-check-label">Vialidad</label>
                  </div>
                  <div className="form-check mx-auto col-6 col-lg-3">
                    <input
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="servicios"
                      onChange={checked}
                      name="serv8"
                      checked={
                        servPublic.serv8.toString() === "1" ? true : false
                      }
                    />
                    <label className="form-check-label">Pavimento</label>
                  </div>
                  <div className="form-check mx-auto col-6 col-lg-3">
                    <input
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="servicios"
                      onChange={checked}
                      name="serv9"
                      checked={
                        servPublic.serv9.toString() === "1" ? true : false
                      }
                    />
                    <label className="form-check-label">Acera</label>
                  </div>
                  <div className="form-check mx-auto col-6 col-lg-3">
                    <input
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="servicios"
                      onChange={checked}
                      name="serv10"
                      checked={
                        servPublic.serv10.toString() === "1" ? true : false
                      }
                    />
                    <label className="form-check-label">Transporte</label>
                  </div>
                  <div className="form-check mx-auto col-6 col-lg-3">
                    <input
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="servicios"
                      onChange={checked}
                      name="serv11"
                      checked={
                        servPublic.serv11.toString() === "1" ? true : false
                      }
                    />
                    <label className="form-check-label">Telefono</label>
                  </div>
                  <div className="form-check mx-auto col-6 col-lg-3">
                    <input
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="servicios"
                      onChange={checked}
                      name="serv12"
                      checked={
                        servPublic.serv12.toString() === "1" ? true : false
                      }
                    />
                    <label className="form-check-label">
                      Cobertura Celular
                    </label>
                  </div>
                  <div className="form-check mx-auto col-6 col-lg-3">
                    <input
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="servicios"
                      onChange={checked}
                      name="serv13"
                      checked={
                        servPublic.serv13.toString() === "1" ? true : false
                      }
                    />
                    <label className="form-check-label">Cable TV</label>
                  </div>
                  <div className="form-check mx-auto col-6 col-lg-3">
                    <input
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="servicios"
                      onChange={checked}
                      name="serv14"
                      checked={
                        servPublic.serv14.toString() === "1" ? true : false
                      }
                    />
                    <label className="form-check-label">Correo Telegrafo</label>
                  </div>
                  <div className="form-check mx-auto col-6 col-lg-3">
                    <input
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="servicios"
                      onChange={checked}
                      name="serv15"
                      checked={
                        servPublic.serv15.toString() === "1" ? true : false
                      }
                    />
                    <label className="form-check-label">Gas</label>
                  </div>
                  <div className="form-check mx-auto col-6 col-lg-3">
                    <input
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="servicios"
                      onChange={checked}
                      name="serv16"
                      checked={
                        servPublic.serv16.toString() === "1" ? true : false
                      }
                    />
                    <label className="form-check-label">Aseo</label>
                  </div>
                  <div className="form-check mx-auto col-6 col-lg-3">
                    <input
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="servicios"
                      onChange={checked}
                      name="serv17"
                      checked={
                        servPublic.serv17.toString() === "1" ? true : false
                      }
                    />
                    <label className="form-check-label">Escuelas</label>
                  </div>
                  <div className="form-check mx-auto col-6 col-lg-3">
                    <input
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="servicios"
                      onChange={checked}
                      name="serv18"
                      checked={
                        servPublic.serv18.toString() === "1" ? true : false
                      }
                    />
                    <label className="form-check-label">Medicaturas</label>
                  </div>
                  <div className="form-check mx-auto col-6 col-lg-3">
                    <input
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="servicios"
                      onChange={checked}
                      name="serv19"
                      checked={
                        servPublic.serv19.toString() === "1" ? true : false
                      }
                    />
                    <label className="form-check-label">Riego</label>
                  </div>
                  <div className="form-check mx-auto col-6 col-lg-3"></div>
                </div>
              </fieldset>
              <div className="col-12 m-0 my-2 p-0">
                <Input
                  label="Observación:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={txtObsTerr}
                  value={
                    values && values.obserterreno ? values.obserterreno : ""
                  }
                  name="obserterreno"
                  onChange={onChange}
                />
              </div>
              <div className="col-12 m-0 p-0 d-flex gap-2">
                <div className="col-4 m-0 p-0">
                  <SearchInput
                    label="Clasificación del Terreno:"
                    ref={txtIdClaseTerreno}
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    onKeyUp={validarClasificador}
                    onBlur={validarClasificador}
                    name="idclaseterreno"
                    onChange={onChange}
                    onClickButton={() => setShowClasificador(true)}
                  />
                </div>
                <Input disabled ref={txtDesClaseTerreno} />
              </div>
            </fieldset>
          </div>
          <div
            className={tabPanel.tab4}
            id="tab4"
            role="tabpanel"
            aria-labelledby="ex-with-icons-tab-4"
          >
            <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
              <legend className="float-none w-auto m-0">
                Datos Generales de la Construcción
              </legend>
              <div className="col-8 m-0 mb-2 p-0">
                <Select
                  label="1-Descripción de Uso:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={cmbClaseInm}
                  name="idclaseinmueble"
                  onChange={onChange}
                  value={
                    values.idclaseinmueble !== "" ? values.idclaseinmueble : ""
                  }
                >
                  {uso &&
                    uso.map((sta) => (
                      <option
                        key={sta.idclaseinmueble}
                        value={sta.idclaseinmueble}
                      >
                        {sta.descripcion}
                      </option>
                    ))}
                </Select>
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Select
                  label="2-Clasificación del Inmueble:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={cmbTipoInm}
                  value={
                    values.idtipoinmueble ? values.idtipoinmueble.trim() : ""
                  }
                  name="idtipoinmueble"
                  onChange={onChange}
                >
                  {tipoInmueble &&
                    tipoInmueble.map((sta) => (
                      <option
                        key={sta.idtipoinmueble}
                        value={sta.idtipoinmueble}
                      >
                        {sta.descripcion}
                      </option>
                    ))}
                </Select>
              </div>
              <div className="col-6 m-0 p-0">
                <Select
                  label="3-Tenencia Construcción:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={cmbTenConst}
                  value={
                    values && values.tenenciaterreno
                      ? values.tenenciaterreno.trim()
                      : ""
                  }
                  name="tenenciaterreno"
                  onChange={onChange}
                >
                  <option value="">--</option>
                  <option value="PROPIEDAD">PROPIEDAD</option>
                  <option value="ARRENDAMIENTO">ARRENDAMIENTO</option>
                  <option value="COMODATO">COMODATO</option>
                  <option value="ANTICRESIS">ANTICRESIS</option>
                  <option value="ENFITUSIS">ENFITUSIS</option>
                  <option value="DERECHO USO">DERECHO USO</option>
                  <option value="DERECHO HABITACION">DERECHO HABITACION</option>
                </Select>
              </div>
              <div className="col-6 m-0 p-0 pl-2">
                <Select
                  label="Régimen de Propiedad:"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={cmbRegimenPropi}
                  value={
                    values && values.regpropieconstruccion
                      ? values.regpropieconstruccion.trim()
                      : ""
                  }
                  name="regpropieconstruccion"
                  onChange={onChange}
                >
                  <option value="">--</option>
                  <option value="NUNICIPAL PROPIO">NUNICIPAL PROPIO</option>
                  <option value="NACIONAL">NACIONAL</option>
                  <option value="ESTADAL">ESTADAL</option>
                  <option value="PRIVADO INDIVIDUAL">PRIVADO INDIVIDUAL</option>
                  <option value="PRIVADO CONDOMINIO">PRIVADO CONDOMINIO</option>
                </Select>
              </div>
            </fieldset>
            <fieldset className="col-12 m-0 p-2 d-flex border-azul">
              <legend className="float-none w-auto m-0">
                Datos Estructurales de la Contrucción
              </legend>
              <div className="col-6 px-0 bg-light p-2">
                <legend className="float-none w-auto m-0">1-Soporte</legend>
                <div className="col-lg-12 mx-auto container">
                  <div className="pl-3 row row-cols-1 row-cols-lg-2">
                    <div className="col form-check">
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="soporte"
                        onChange={checked}
                        name="sopor1"
                        checked={
                          soporte.sopor1.toString() === "1" ? true : false
                        }
                      />
                      <label className="form-check-label">
                        Concreto Armado
                      </label>
                    </div>
                    <div className="col form-check">
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="soporte"
                        onChange={checked}
                        name="sopor2"
                        checked={
                          soporte.sopor2.toString() === "1" ? true : false
                        }
                      />
                      <label className="form-check-label">Metálica</label>
                    </div>
                    <div className="col form-check">
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="soporte"
                        onChange={checked}
                        name="sopor3"
                        checked={
                          soporte.sopor3.toString() === "1" ? true : false
                        }
                      />
                      <label className="form-check-label">Madera</label>
                    </div>
                    <div className="col form-check">
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="soporte"
                        onChange={checked}
                        name="sopor4"
                        checked={
                          soporte.sopor4.toString() === "1" ? true : false
                        }
                      />
                      <label className="form-check-label">
                        Paredes de Carga
                      </label>
                    </div>
                    <div className="col form-check">
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="soporte"
                        onChange={checked}
                        name="sopor5"
                        checked={
                          soporte.sopor5.toString() === "1" ? true : false
                        }
                      />
                      <label className="form-check-label">Prefabricado</label>
                    </div>
                    <div className="col form-check">
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="soporte"
                        onChange={checked}
                        name="sopor6"
                        checked={
                          soporte.sopor6.toString() === "1" ? true : false
                        }
                      />
                      <label className="form-check-label">Machones</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6 px-0 bg-light p-2">
                <legend className="float-none w-auto m-0">2-Techo</legend>
                <div className="col-lg-12">
                  <div className="pl-3 row row-cols-1 row-cols-lg-2">
                    <div className="col form-check">
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="techo"
                        name="techo1"
                        onChange={checked}
                        checked={techo.techo1.toString() === "1" ? true : false}
                      />
                      <label className="form-check-label">
                        Concreto Armado
                      </label>
                    </div>
                    <div className="col form-check">
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="techo"
                        name="techo2"
                        onChange={checked}
                        checked={techo.techo2.toString() === "1" ? true : false}
                      />
                      <label className="form-check-label">Metálica</label>
                    </div>
                    <div className="col form-check">
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="techo"
                        name="techo3"
                        onChange={checked}
                        checked={techo.techo3.toString() === "1" ? true : false}
                      />
                      <label className="form-check-label">Madera</label>
                    </div>
                    <div className="col form-check">
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="techo"
                        name="techo4"
                        onChange={checked}
                        checked={techo.techo4.toString() === "1" ? true : false}
                      />
                      <label className="form-check-label">Veras</label>
                    </div>
                    <div className="col form-check">
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="techo"
                        name="techo5"
                        onChange={checked}
                        checked={techo.techo5.toString() === "1" ? true : false}
                      />
                      <label className="form-check-label">Cerchas</label>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
            <fieldset className="col-12 m-0 p-2 border-azul rounded">
              <legend className="float-none w-auto m-0">Cubierta</legend>
              <div className="col-12 d-flex flex-wrap py-2 px-4 bg-light">
                <div className="form-check mx-auto col-6 col-lg-3">
                  <input
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="cubierta"
                    name="cubi1"
                    onChange={checked}
                    checked={cubierta.cubi1.toString() === "1" ? true : false}
                  />
                  <label className="form-check-label">Madera-Teja</label>
                </div>
                <div className="form-check mx-auto col-6 col-lg-3">
                  <input
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="cubierta"
                    name="cubi2"
                    onChange={checked}
                    checked={cubierta.cubi2.toString() === "1" ? true : false}
                  />
                  <label className="form-check-label">Placa-Teja</label>
                </div>
                <div className="form-check mx-auto col-6 col-lg-3">
                  <input
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="cubierta"
                    name="cubi3"
                    onChange={checked}
                    checked={cubierta.cubi3.toString() === "1" ? true : false}
                  />
                  <label className="form-check-label">Platabanda</label>
                </div>
                <div className="form-check mx-auto col-6 col-lg-3">
                  <input
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="cubierta"
                    name="cubi4"
                    onChange={checked}
                    checked={cubierta.cubi4.toString() === "1" ? true : false}
                  />
                  <label className="form-check-label">Tejas/Caña Brava</label>
                </div>
                <div className="form-check mx-auto col-6 col-lg-3">
                  <input
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="cubierta"
                    name="cubi5"
                    onChange={checked}
                    checked={cubierta.cubi5.toString() === "1" ? true : false}
                  />
                  <label className="form-check-label">Asbesto</label>
                </div>
                <div className="form-check mx-auto col-6 col-lg-3">
                  <input
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="cubierta"
                    name="cubi6"
                    onChange={checked}
                    checked={cubierta.cubi6.toString() === "1" ? true : false}
                  />
                  <label className="form-check-label">Aluminio</label>
                </div>
                <div className="form-check mx-auto col-6 col-lg-3">
                  <input
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="cubierta"
                    name="cubi7"
                    onChange={checked}
                    checked={cubierta.cubi7.toString() === "1" ? true : false}
                  />
                  <label className="form-check-label">Zinc</label>
                </div>
                <div className="form-check mx-auto col-6 col-lg-3">
                  <input
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="cubierta"
                    name="cubi8"
                    onChange={checked}
                    checked={cubierta.cubi8.toString() === "1" ? true : false}
                  />
                  <label className="form-check-label">Acerolit</label>
                </div>
                <div className="form-check mx-auto col-6 col-lg-3">
                  <input
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="cubierta"
                    name="cubi9"
                    onChange={checked}
                    checked={cubierta.cubi9.toString() === "1" ? true : false}
                  />
                  <label className="form-check-label">Palma</label>
                </div>
                <div className="col-6 col-lg-3"></div>
                <div className="d-none d-lg-block col-6 col-lg-3"></div>
                <div className="d-none d-lg-block col-6 col-lg-3"></div>
              </div>
            </fieldset>
            <fieldset className="col-12 m-0 p-2 border-azul rounded">
              <legend className="float-none w-auto m-0">
                Datos Complementarios de la Construcción
              </legend>
              <fieldset className="col-12 m-0 p-0 px-2 d-flex rounded border-azul">
                <legend className="float-none w-auto m-0">1-Paredes</legend>
                <div className="col-6 m-0 p-2">
                  <legend className="float-none w-auto m-0">1.1-Tipo</legend>
                  <div className="col-md-12 container">
                    <div className="pl-2 row row-cols-1 row-cols-lg-3">
                      <div className="col form-check">
                        <input
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="tipo"
                          name="pared1"
                          onChange={checked}
                          checked={
                            tipoPared.pared1.toString() === "1" ? true : false
                          }
                        />
                        <label className="form-check-label">
                          Bloque Cemento
                        </label>
                      </div>
                      <div className="col form-check">
                        <input
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="tipo"
                          name="pared2"
                          onChange={checked}
                          checked={
                            tipoPared.pared2.toString() === "1" ? true : false
                          }
                        />
                        <label className="form-check-label">
                          Bloque de Arcilla
                        </label>
                      </div>
                      <div className="col form-check">
                        <input
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="tipo"
                          name="pared3"
                          onChange={checked}
                          checked={
                            tipoPared.pared3.toString() === "1" ? true : false
                          }
                        />
                        <label className="form-check-label">Ladrillo</label>
                      </div>
                      <div className="col form-check">
                        <input
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="tipo"
                          name="pared4"
                          onChange={checked}
                          checked={
                            tipoPared.pared4.toString() === "1" ? true : false
                          }
                        />
                        <label className="form-check-label">Adobe</label>
                      </div>
                      <div className="col form-check">
                        <input
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="tipo"
                          name="pared5"
                          onChange={checked}
                          checked={
                            tipoPared.pared5.toString() === "1" ? true : false
                          }
                        />
                        <label className="form-check-label">Tapia</label>
                      </div>
                      <div className="col form-check">
                        <input
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="tipo"
                          name="pared6"
                          onChange={checked}
                          checked={
                            tipoPared.pared6.toString() === "1" ? true : false
                          }
                        />
                        <label className="form-check-label">Bahareque</label>
                      </div>
                      <div className="col form-check">
                        <input
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="tipo"
                          n
                          ame="pared7"
                          onChange={checked}
                          checked={
                            tipoPared.pared7.toString() === "1" ? true : false
                          }
                        />
                        <label className="form-check-label">Prefabricada</label>
                      </div>
                      <div className="col form-check">
                        <input
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="tipo"
                          name="pared8"
                          onChange={checked}
                          checked={
                            tipoPared.pared8.toString() === "1" ? true : false
                          }
                        />
                        <label className="form-check-label">Vidrio</label>
                      </div>
                      <div className="col form-check">
                        <input
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="tipo"
                          name="pared9"
                          onChange={checked}
                          checked={
                            tipoPared.pared9.toString() === "1" ? true : false
                          }
                        />
                        <label className="form-check-label">
                          Madera Aserrada
                        </label>
                      </div>
                      <div className="col form-check">
                        <input
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="tipo"
                          name="pared10"
                          onChange={checked}
                          checked={
                            tipoPared.pared10.toString() === "1" ? true : false
                          }
                        />
                        <label className="form-check-label">Sin Paredes</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6 m-0 p-2">
                  <legend className="float-none w-auto m-0">1.2-Acabado</legend>
                  <div className="col-md-12">
                    <div className="form-check mx-auto">
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="acabado"
                        onChange={checked}
                        name="acab1"
                        checked={
                          acabado.acab1.toString() === "1" ? true : false
                        }
                      />
                      <label className="form-check-label">Friso Liso</label>
                    </div>
                    <div className="form-check mx-auto">
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="acabado"
                        onChange={checked}
                        name="acab2"
                        checked={
                          acabado.acab2.toString() === "1" ? true : false
                        }
                      />
                      <label className="form-check-label">Friso Rústico</label>
                    </div>
                    <div className="form-check mx-auto">
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="acabado"
                        onChange={checked}
                        name="acab3"
                        checked={
                          acabado.acab3.toString() === "1" ? true : false
                        }
                      />
                      <label className="form-check-label">Sin Friso</label>
                    </div>
                    <div className="form-check mx-auto">
                      <input
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="acabado"
                        onChange={checked}
                        name="acab4"
                        checked={
                          acabado.acab4.toString() === "1" ? true : false
                        }
                      />
                      <label className="form-check-label">Obra Limpia</label>
                    </div>
                  </div>
                </div>
              </fieldset>
              <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                <legend className="float-none w-auto m-0">Otros Datos</legend>
                <div className="col-3 m-0 mb-2 p-0">
                  <Select
                    label="Estado Conservación:"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={cmbEstConser}
                    value={
                      values && values.estadoconsevacion
                        ? values.estadoconsevacion.trim()
                        : ""
                    }
                    name="estadoconsevacion"
                    onChange={onChange}
                  >
                    <option value="">--</option>
                    <option value="EXCELENTE">EXCELENTE</option>
                    <option value="BUENO">BUENO</option>
                    <option value="REGULAR">REGULAR</option>
                    <option value="MALO">MALO</option>
                  </Select>
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input
                    label="Año Construcción:"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtAnioConst}
                    onKeyUp={handleInputNumChange}
                    onBlur={handleInputNumChange}
                    value={
                      values && values.anioconstruccion
                        ? values.anioconstruccion !== "" ||
                          values.anioconstruccion !== null
                          ? values.anioconstruccion
                          : "0"
                        : "0"
                    }
                    name="anioconstruccion"
                    onChange={onChange}
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input
                    label="% Refacción:"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtPorcenRefa}
                    onKeyUp={handleInputNumChange}
                    onBlur={handleInputNumChange}
                    value={
                      values && values.porcentajerefaccion
                        ? values.porcentajerefaccion !== "" ||
                          values.porcentajerefaccion !== null
                          ? formatMoneda(
                              values.porcentajerefaccion
                                .toString()
                                .replace(".", ","),
                              ",",
                              ".",
                              2,
                            )
                          : "0"
                        : "0"
                    }
                    name="porcentajerefaccion"
                    onChange={onChange}
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input
                    label="Año Refacción:"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtAnioRefa}
                    onKeyUp={handleInputNumChange}
                    onBlur={handleInputNumChange}
                    value={
                      values.aniorefaccion !== "" ? values.aniorefaccion : ""
                    }
                    name="aniorefaccion"
                    onChange={onChange}
                  />
                </div>
                <div className="col-3 m-0 p-0">
                  <Input
                    label="N° Niveles:"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtNNiv}
                    onKeyUp={handleInputNumChange}
                    onBlur={handleInputNumChange}
                    value={values.numniveles !== "" ? values.numniveles : ""}
                    name="numniveles"
                    onChange={onChange}
                  />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input
                    label="N° Edificaciones:"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtNEdifi}
                    onKeyUp={handleInputNumChange}
                    onBlur={handleInputNumChange}
                    value={
                      values.numedificaciones !== ""
                        ? values.numedificaciones
                        : ""
                    }
                    name="numedificaciones"
                    onChange={onChange}
                  />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input
                    label="Edad Efectiva:"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtEdadEfec}
                    onKeyUp={handleInputNumChange}
                    onBlur={handleInputNumChange}
                    value={
                      values.edadefectiva !== "" ? values.edadefectiva : ""
                    }
                    name="edadefectiva"
                    onChange={onChange}
                  />
                </div>
              </fieldset>
            </fieldset>
          </div>
          <div
            className={tabPanel.tab5}
            id="tab5"
            role="tabpanel"
            aria-labelledby="ex-with-icons-tab-5"
          >
            <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
              <legend className="float-none w-auto m-0">
                Datos del Registro Público
              </legend>
              <div className="col-11 m-0 p-0">
                <TblContainer
                  container={{
                    height: 150,
                    width: "100%",
                    overflow: "auto",
                    padding: "2px",
                  }}
                >
                  <TblHead />

                  <tbody>
                    {records &&
                      records.map((item, index) => (
                        <tr
                          key={index}
                          style={{
                            padding: "0",
                            cursor: "pointer",
                            background:
                              itemSelectR.index === index
                                ? "lightskyblue"
                                : "white",
                          }}
                          onClick={(e) => {
                            seleccionarFila(item, index);
                          }}
                          disabled
                        >
                          <td
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                            }}
                          >
                            {item.numeroregistro ? item.numeroregistro : ""}
                          </td>
                          <td
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                            }}
                          >
                            {item.folio !== "" ? item.folio.trim() : ""}
                          </td>
                          <td
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                            }}
                          >
                            {item.tomo !== "" ? item.tomo.trim() : ""}
                          </td>
                          <td
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                            }}
                          >
                            {item.protocolo !== "" ? item.protocolo.trim() : ""}
                          </td>
                          <td
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                            }}
                          >
                            {item.asientoregistral
                              ? item.asientoregistral.trim()
                              : ""}
                          </td>
                          <td
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                            }}
                          >
                            {item.fecharegistro !== ""
                              ? moment
                                  .utc(item.fecharegistro)
                                  .format("YYYY-MM-DD")
                              : ""}
                          </td>
                          <td style={{ fontSize: "10px", textAlign: "right" }}>
                            {item.areaterreno
                              ? formatMoneda(
                                  item.areaterreno.toString().replace(".", ","),
                                  ",",
                                  ".",
                                  2,
                                )
                              : ""}
                          </td>
                          <td style={{ fontSize: "10px", textAlign: "right" }}>
                            {formatMoneda(
                              item.areaconstruccion
                                .toString()
                                .replace(".", ","),
                              ",",
                              ".",
                              2,
                            )}
                          </td>
                          <td style={{ fontSize: "10px", textAlign: "right" }}>
                            {formatMoneda(
                              item.valorinmueble.toString().replace(".", ","),
                              ",",
                              ".",
                              2,
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </TblContainer>
                {/*<TblPagination />*/}
              </div>
              <div className="col-1 m-0 p-0 d-flex flex-column align-items-center justify-content-center gap-2">
                <div className="col-auto m-0 p-0">
                  <PrimaryButton
                    icon="fa-plus m-0"
                    onClick={registroPublico(1)}
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                  />
                </div>
                <div className="col-auto m-0 p-0">
                  <WarningButton
                    icon="fa-edit m-0"
                    onClick={registroPublico(2)}
                    disabled={activo}
                  />
                </div>
                <div className="col-auto m-0 p-0">
                  <DangerButton
                    icon="fa-trash-alt m-0"
                    onClick={registroPublico(3)}
                    disabled={activo}
                  />
                </div>
              </div>
            </fieldset>
            <fieldset className="col-12 m-0 p-2 border-azul rounded ">
              <legend className="float-none w-auto m-0">Construcción</legend>
              <TablaConstrucciones records={records2} />
            </fieldset>
          </div>
          <div
            className={tabPanel.tab6}
            id="tab6"
            role="tabpanel"
            aria-labelledby="ex-with-icons-tab-6"
          >
            <div className="col-12 m-0 p-0 d-flex">
              <div className="col-12 col-lg-6 m-0 p-0">
                <fieldset className="col-12 m-0 p-2 border-azul rounded">
                  <legend className="float-none w-auto m-0">
                    Linderos Actuales
                  </legend>
                  <div className="col-12 m-0 mb-2 p-0">
                    <Textarea
                      label="Norte"
                      style={{ height: 70 }}
                      placeholder="Describe el lindero"
                      name="linderonorte"
                      onChange={onChange}
                      value={
                        values.linderonorte
                          ? values.linderonorte !== "" ||
                            values.linderonorte !== null
                            ? values.linderonorte
                            : ""
                          : ""
                      }
                      ref={txtLinderoNorte}
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                    ></Textarea>
                  </div>
                  <div className="col-12 m-0 mb-2 p-0">
                    <Textarea
                      label="Sur"
                      style={{ height: 70 }}
                      placeholder="Describe el lindero"
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      ref={txtLinderoSur}
                      value={
                        values.linderosur
                          ? values.linderosur !== "" ||
                            values.linderosur !== null
                            ? values.linderosur
                            : ""
                          : ""
                      }
                      name="linderosur"
                      onChange={onChange}
                    />
                  </div>
                  <div className="col-12 m-0 mb-2 p-0">
                    <Textarea
                      label="Este"
                      style={{ height: 70 }}
                      placeholder="Describe el lindero"
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      ref={txtLinderoEste}
                      value={
                        values.linderoeste
                          ? values.linderoeste !== "" ||
                            values.linderoeste !== null
                            ? values.linderoeste
                            : ""
                          : ""
                      }
                      name="linderoeste"
                      onChange={onChange}
                    />
                  </div>
                  <div className="col-12 m-0 p-0">
                    <Textarea
                      label="Oeste"
                      style={{ height: 70 }}
                      placeholder="Describe el lindero"
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      ref={txtLinderoOeste}
                      value={
                        values.linderooeste
                          ? values.linderooeste !== "" ||
                            values.linderooeste !== null
                            ? values.linderooeste
                            : ""
                          : ""
                      }
                      name="linderooeste"
                      onChange={onChange}
                    />
                  </div>
                </fieldset>
                <fieldset className="col-12 m-0 p-2 d-flex gap-2 border-azul rounded">
                  <legend className="float-none w-auto m-0">
                    Coordenadas Geográficas
                  </legend>
                  <div className="col m-0 p-0">
                    <Input
                      label="Latitud:"
                      id="latitud"
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      ref={txtLatitud}
                      value={latitud}
                      name="utmeste"
                    />
                  </div>
                  <div className="col m-0 p-0">
                    <Input
                      label="Longitud:"
                      id="longitud"
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      ref={txtLongitud}
                      value={longitud}
                      name="utmnorte"
                    />
                  </div>
                </fieldset>
                <fieldset className="col-12 m-0 p-2 d-flex gap-2 border-azul rounded">
                  <legend className="float-none w-auto m-0">
                    Puntos de Vonculación a la Red Geodesica
                  </legend>
                  <div className="col m-0 p-0">
                    <Input
                      label="Punto"
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      ref={txtPuntogeo}
                      value={
                        values.puntogeo
                          ? values.puntogeo !== "" || values.puntogeo !== null
                            ? values.puntogeo.trim()
                            : ""
                          : ""
                      }
                      name="puntogeo"
                      onChange={onChange}
                    />
                  </div>
                  <div className="col m-0 p-0">
                    <Input
                      label="Norte"
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      ref={txtNortegeo}
                      value={
                        values.nortegeo
                          ? values.nortegeo !== "" || values.nortegeo !== null
                            ? values.nortegeo.trim()
                            : ""
                          : ""
                      }
                      name="nortegeo"
                      onChange={onChange}
                    />
                  </div>
                  <div className="col m-0 p-0">
                    <Input
                      label="Este"
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      ref={txtEstegeo}
                      value={
                        values.estegeo
                          ? values.estegeo !== "" || values.estegeo !== null
                            ? values.estegeo.trim()
                            : ""
                          : ""
                      }
                      name="estegeo"
                      onChange={onChange}
                    />
                  </div>
                </fieldset>
                <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
                  <legend className="float-none w-auto m-0">
                    Poligonal de la Parcela Coordenadas
                  </legend>
                  <div className="col-11 m-0 p-0 pr-2" id="probando">
                    <TblContainer2
                      container={{
                        height: 200,
                        width: "100%",
                        overflow: "auto",
                        padding: "2px",
                      }}
                    >
                      <TblHead2 />
                      <tbody>
                        {records3 &&
                          records3.map((item, index) => (
                            <tr
                              key={index}
                              style={{
                                padding: "0",
                                background:
                                  seleccionarCoordenada?.index === index
                                    ? "lightskyblue"
                                    : "white",
                              }}
                              onClick={() => {
                                setSelectCoordenada({
                                  index: index,
                                  item: item,
                                });
                              }}
                            >
                              <td
                                style={{
                                  fontSize: "10px",
                                  textAlign: "center",
                                }}
                              >
                                {item.vertice}
                              </td>
                              <td
                                style={{
                                  fontSize: "10px",
                                  textAlign: "center",
                                }}
                              >
                                {item.norte}
                              </td>
                              <td
                                style={{
                                  fontSize: "10px",
                                  textAlign: "center",
                                }}
                              >
                                {item.este}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </TblContainer2>
                    {/*<TblPagination />*/}
                  </div>
                  <div className="col-1 m-0 p-0 d-flex flex-column align-items-center justify-content-center gap-2">
                    <div className="col-auto m-0 p-0">
                      <PrimaryButton
                        onClick={() =>
                          setModalCoordenadas({
                            show: true,
                            operacion: 1,
                          })
                        }
                        icon="fa-plus m-0"
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <DangerButton
                        onClick={() =>
                          setModalCoordenadas({
                            show: true,
                            operacion: 3,
                          })
                        }
                        icon="fa-trash-alt m-0"
                        disabled={seleccionarCoordenada?.index < 0}
                      />
                    </div>
                  </div>
                </fieldset>
              </div>
              <div className="col-12 col-lg-6 m-0 p-0 px-2">
                <fieldset className="col-12 m-0 mb-2 p-1 border-azul rounded d-flex flex-column align-items-center">
                  <legend className="float-none w-auto m-0 p-0">Mapa</legend>
                  <button
                    className="btn btn-sm rounded-pill btn-info mb-2"
                    onClick={() => {
                      setLatitud("9.549884372804192");
                      setLongitud("-69.20455936500002");
                    }}
                  >
                    <i className="fas fa-sync-alt" /> Reiniciar
                  </button>
                  <div style={{ height: "300px", width: "100% " }}>
                    <MapaCatastro
                      setLatitud={setLatitud}
                      setLongitud={setLongitud}
                      latitud={latitud}
                      longitud={longitud}
                    />
                  </div>
                </fieldset>
                <fieldset className="col-12 m-0 mb-2 p-2 border-azul rounded">
                  <legend className="float-none w-auto">
                    Plano Referencial
                  </legend>
                  <img
                    style={{
                      height: "100px",
                      width: "100px",
                      maxHeight: "300px",
                      maxWidth: "300px",
                      marginLeft: "200px",
                    }}
                    src={pathImage.imagen}
                    alt=""
                  />
                  <input
                    type="file"
                    onChange={handleUpload}
                    style={{
                      position: "absolute",
                      height: "100px",
                      padding: 0,
                      top: 0,
                      left: "205px",
                      width: "100px",
                      cursor: "pointer",
                      opacity: 0.01,
                    }}
                    name="imagen"
                    accept="image/jpeg, image/png"
                    className="col-12 mt-2 mx-auto"
                  />
                </fieldset>
                <fieldset className="col-12 m-0 p-2 border-azul rounded">
                  <legend className="float-none w-auto">Fachada</legend>
                  <img
                    style={{
                      height: "100px",
                      width: "100px",
                      maxHeight: "300px",
                      maxWidth: "300px",
                      marginLeft: "200px",
                    }}
                    src={pathImage2.imagen}
                    alt=""
                  />
                  <input
                    type="file"
                    onChange={handleUpload2}
                    style={{
                      position: "absolute",
                      height: "100px",
                      padding: 0,
                      top: 0,
                      left: "205px",
                      width: "100px",
                      cursor: "pointer",
                      opacity: 0.01,
                    }}
                    name="imagen"
                    accept="image/jpeg, image/png"
                    className="col-12 mt-2 mx-auto"
                  />
                </fieldset>
              </div>
            </div>
          </div>
          <div
            className={tabPanel.tab7}
            id="tab7"
            role="tabpanel"
            aria-labelledby="ex-with-icons-tab-7"
          >
            <TablaDeudaInmueble
              tabDeuda={props.deuda}
              idinmueble={props.inmueble && props.inmueble.idinmueble}
              credito={props.credito && props.credito > 0 ? props.credito : 0.0}
            />
          </div>
          <div
            className={tabPanel.tab8}
            id="tab8"
            role="tabpanel"
            aria-labelledby="ex-with-icons-tab-8"
          >
            <TablaHistoricosInmuebles
              tabHis={props.historico}
              idinmueble={props.inmueble && props.inmueble.idinmueble}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {operacion !== 4 && (
          <SuccessButton
            ref={btnAcepta}
            onClick={onChangeValidar}
            className="btn btn-sm btn-success rounded-pill"
          >
            {operacion === 3
              ? " Eliminar"
              : operacion === 2
                ? " Modificar"
                : " Guardar"}
          </SuccessButton>
        )}
        <DangerButton ref={btnCancela} onClick={cancelar}>
          Cancelar
        </DangerButton>
      </Modal.Footer>
      <AgregarRegistroInm
        show={mostrarRegsitro}
        onHideCancela={() => {
          setMostrarRegistro(false);
        }}
        operacion={operacionP}
        operacionFicha={operacion}
        agregarDetalle={agregarDetalle}
        detalle={detalle}
        renderDetalles={seleccionaRegistrosDetalles}
        idinmueble={idinmu}
      />
      <ModalCoordenadas
        show={modalCoordenadas.show}
        onHide={() =>
          setModalCoordenadas({
            show: false,
            operacion: 1,
          })
        }
        operacion={modalCoordenadas.operacion}
        idInmueble={idinmu}
        buscarCoordenadas={() => {
          buscarCoordenadas(idinmu);
          setSelectCoordenada({
            index: -1,
            item: [],
          });
        }}
        coordenadas={seleccionarCoordenada.item}
      />
      <ModalClaseTerreno 
        show={showClasificador}
        setHidden={() => setShowClasificador(false)}
        seleccionarClasificador={seleccionarClasificador}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
